import React, { Component, Fragment } from 'react';
import {taxRateBefore20191001, taxRateAfter20191001, taxChangeBorder, bedPrice, mealPrice, roomPlans, roomNames, roomTypes} from './Settings';
import AuthService from './services/AuthService'
import PropTypes from 'prop-types';
import { API } from 'aws-amplify';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import { phone, user, envelopeOpen, file, remove } from 'react-icons-kit/fa/'
import ListItemIcon from '@material-ui/core/ListItemIcon';
import SvgIcon from 'react-icons-kit';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Chip from '@material-ui/core/Chip';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import ErrorIcon from '@material-ui/icons/Error';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import moment from 'moment';
import axios from 'axios';
import cheerio from 'cheerio'
import { withSnackbar } from 'notistack';
import ReactToPrint from "react-to-print";

class Letter extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      ...props.state
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      ...nextProps.state
    })
  }

  calculatePlanTotal = (plans, isJalan, jalanPaid, extraCharge, discount, jalanCoupon, jalanPoint, jalanSubsidy) => {
    let total = 0;

    if(jalanPaid === "yes"){
      return total;
    }

    plans.map(n => {
      total += (Number(n.unitPrice) * Number(n.amount))
      return true;
    })

    if(isJalan === "no"){
      total += Number(extraCharge);
      total -= Number(discount);
    }

    if(isJalan === "yes"){
      total -= Number(jalanCoupon);
      total -= Number(jalanPoint);
      total -= Number(jalanSubsidy);
    }


    return total;
  }

  calculateTaxTotal = (plans, isJalan, jalanPaid, extraCharge, discount, jalanCoupon, jalanPoint, jalanSubsidy, orders, taxRate) => {
    let tax = 0;

    if(isJalan === "no"){
      tax += Math.floor(this.calculatePlanTotal(plans, isJalan, jalanPaid, extraCharge, discount, jalanCoupon, jalanPoint, jalanSubsidy) * Number(taxRate))
    }

    if(isJalan === "yes"){
      tax += Math.floor(this.calculatePlanTotal(plans, isJalan, jalanPaid, extraCharge, discount, jalanCoupon, jalanPoint, jalanSubsidy) * (Number(taxRate)) / (1 + Number(taxRate)))
    }

    tax += Math.floor(this.calculateOrderOuterTaxTotal(orders) * Number(taxRate))

    tax += Math.floor(this.calculateOrderInnerTaxTotal(orders) * (Number(taxRate)) / (1 + Number(taxRate)))

    return tax;

  }

  calculateTotal = (plans, isJalan, jalanPaid, extraCharge, discount, jalanCoupon, jalanPoint, jalanSubsidy, orders, taxRate) => {
    let total = 0;

    if(isJalan === "no"){
      total += Math.floor(this.calculatePlanTotal(plans, isJalan, jalanPaid, extraCharge, discount, jalanCoupon, jalanPoint, jalanSubsidy) * (1 + Number(taxRate)))
    }

    if(isJalan === "yes"){
      total += this.calculatePlanTotal(plans, isJalan, jalanPaid, extraCharge, discount, jalanCoupon, jalanPoint, jalanSubsidy)
    }

    total += Math.floor(this.calculateOrderOuterTaxTotal(orders) * (1 + Number(taxRate)))

    total += this.calculateOrderInnerTaxTotal(orders)

    return total;

  }

  calculateOrderOuterTaxTotal = (orders) => {
    let total = 0;

    orders.map(n => {
      if(n.taxType === "税別"){
        total += Number(n.price) * Number(n.amount)
      }
      return true;
    })

    return total;
  }

  calculateOrderInnerTaxTotal = (orders,taxRate) => {
    let total = 0;

    orders.map(n => {
      if(n.taxType === "税込"){
        total += Number(n.price) * Number(n.amount)
      }
      return true;
    })

    return total;
  }

  getPrintRoomTypes = (rooms) => {
    let printRoomTypes = []

    if(
      rooms.some((n) => {
        if(roomTypes.twin.rooms.includes(n)){
          return true
        }
        return false
      })
    ){
      printRoomTypes.push(roomTypes.twin.name)
    }

    if(
      rooms.some((n) => {
        if(roomTypes.triple.rooms.includes(n)){
          return true
        }
        return false
      })
    ){
      printRoomTypes.push(roomTypes.triple.name)
    }

    if(
      rooms.some((n) => {
        if(roomTypes.quartette.rooms.includes(n)){
          return true
        }
        return false
      })
    ){
      printRoomTypes.push(roomTypes.quartette.name)
    }

    if(
      rooms.some((n) => {
        if(roomTypes.regular.rooms.includes(n)){
          return true
        }
        return false
      })
    ){
      printRoomTypes.push(roomTypes.regular.name)
    }

    if(
      rooms.some((n) => {
        if(roomTypes.cottage.rooms.includes(n)){
          return true
        }
        return false
      })
    ){
      printRoomTypes.push(roomTypes.cottage.name)
    }

    return printRoomTypes
  }

  render() {
    return (
      <div className="letter">
      <link rel="stylesheet" href="../css/Letter.css" />
        <div className="letterBody" key={this.state.printReservaion.reservation_id}>
          <div className="clearfix" key={this.state.printReservaion.reservation_id + "2"}>

            <div id="project">
              〒{this.state.printCustomer.post_num.substr(0,3)}-{this.state.printCustomer.post_num.substr(3,4)}<br/>
              {this.state.printCustomer.address_prefectures} {this.state.printCustomer.address_city} {this.state.printCustomer.address_other}<br/>
              {this.state.printCustomer.address_building ? this.state.printCustomer.address_building : ""}<br/><br/>
              <p id="name">
              {this.state.printCustomer.last_name} {this.state.printCustomer.first_name} 様
              </p>
            </div>

            <div id="company">
              <div id="logo">
                <img src="../images/funwarikon.png" alt="logo" />
              </div>
              <div id="logoAddress">〒410-1231 静岡県 裾野市 須山 2255-3810</div>
            </div>

            <h1 style={{ background: 'url("/images/leaves.png")'}}>ご案内</h1>
            <div id="main">
              　{this.state.printCustomer.last_name}様、この度はペンションふんわりこんにご予約いただきまして、誠にありがとうございます。
              下記の通りご予約を承りましたので、ご確認ください。
              ふんわりこんは、家族で経営している小さなペンションです。
              真心込めておもてなしさせていただきますので、よろしくお願いいたします。
              お会いできる日をスタッフ一同こころよりお待ち申し上げます。
            </div>

            <div id="dateAndRoom">
              <div>
                  <span className="col-1">ご宿泊日程　 :</span>
                  <span className="col-2">
                    {moment(this.state.printReservaion.date).format("YYYY年M月D日（ddd）")} から {this.state.printReservaion.date_num}泊
                  </span>
              </div>
              {this.getPrintRoomTypes(this.state.printReservaion.input_rooms).map((m, i) => {
                if(i === 0){
                  return(
                    <div key={m}>
                        <span key={m + "col-1-1"} className="col-1">お部屋タイプ :</span>
                        <span key={m + "col-1-2"} className="col-2">{m}</span>
                    </div>
                  )
                }else{
                  return(
                    <div key={m}>
                        <span key={m + "col-2-1"} className="col-1">　　　　　　 </span>
                        <span key={m + "col-2-2"} className="col-2">{m}</span>
                    </div>
                  )
                }

              })}
            </div>

            <main>
              <table>
                <thead>
                  <tr>
                    <th className="desc">ご予約内容</th>
                    <th>単価</th>
                    <th>数量</th>
                    <th>小計</th>
                  </tr>
                </thead>

                <tbody key={this.state.printReservaion.reservation_id}>

                  {this.state.printReservaion.plans.map((m,i) => {

                    return(
                      <tr key={"notJalan" + i}>
                        <td className="desc">{m.basePlan}ご宿泊料（{m.mealPlan === "無" ? "お食事無し" : m.mealPlan}・ベッド{m.bedPlan}）</td>
                        <td className="unit">￥{Number(m.unitPrice).toLocaleString()}</td>
                        <td className="qty">{m.amount}</td>
                        <td className="total">￥{(Number(m.unitPrice) * Number(m.amount)).toLocaleString()}</td>
                      </tr>
                    )

                  })}

                  {(() => {

                    if (this.state.printReservaion.extra_charge && this.state.printReservaion.discount){
                      return (
                        <Fragment>
                          <tr>
                            <td className="desc"></td>
                            <td className="unit"></td>
                            <td className="qty"></td>
                            <td className="total"></td>
                          </tr>
                          <tr>
                            <td className="desc">その他サービス料</td>
                            <td className="unit"></td>
                            <td className="qty"></td>
                            <td className="total">¥{Number(this.state.printReservaion.extra_charge).toLocaleString()}</td>
                          </tr>
                          <tr>
                            <td className="desc">割引額</td>
                            <td className="unit"></td>
                            <td className="qty"></td>
                            <td className="total">¥-{Number(this.state.printReservaion.discount).toLocaleString()}</td>
                          </tr>
                        </Fragment>
                      )
                    }

                    if (this.state.printReservaion.extra_charge){
                      return (
                        <Fragment>
                          <tr>
                            <td className="desc"></td>
                            <td className="unit"></td>
                            <td className="qty"></td>
                            <td className="total"></td>
                          </tr>
                          <tr>
                            <td className="desc">その他サービス料</td>
                            <td className="unit"></td>
                            <td className="qty"></td>
                            <td className="total">¥{Number(this.state.printReservaion.extra_charge).toLocaleString()}</td>
                          </tr>
                        </Fragment>
                      )
                    }

                    if (this.state.printReservaion.discount){
                      return (
                        <Fragment>
                          <tr>
                            <td className="desc"></td>
                            <td className="unit"></td>
                            <td className="qty"></td>
                            <td className="total"></td>
                          </tr>
                          <tr>
                            <td className="desc">割引額</td>
                            <td className="unit"></td>
                            <td className="qty"></td>
                            <td className="total">¥-{Number(this.state.printReservaion.discount).toLocaleString()}</td>
                          </tr>
                        </Fragment>
                      )
                    }
                   })()}

                  <tr>
                    <td colSpan="3" className="grand total">合計金額</td>
                    <td className="grand total">￥{this.calculatePlanTotal(this.state.printReservaion.plans, this.state.printReservaion.is_jalan, this.state.printReservaion.jalan_paid, this.state.printReservaion.extra_charge, this.state.printReservaion.discount, this.state.printReservaion.jalan_coupon, this.state.printReservaion.jalan_point, this.state.printReservaion.jalan_subsidy).toLocaleString()}</td>
                  </tr>

                </tbody>
              </table>

              <div id="after">
                背面に記載の宿泊についてのご案内もご確認いただきますようお願い申し上げます。<br/>
                その他ご不明点等ございましたら、お気軽にお問い合わせくださいませ。<br/>
              </div>

              <div id="caution">

                <h2>チェックイン</h2>
                夕食付きのプランをご予約の方: 15:00 〜 17:30<br/>
                夕食無しのプランをご予約の方: 15:00 〜 22:00<br/><br/>
                ※チェックインに間に合わない場合は、必ずご連絡をお願いいたします。

                <h2>チェックアウト</h2>
                10:00までにチェックアウトをお願いいたします。

                <h2>お食事の時間について</h2>
                ご夕食: 18:00にご用意いたします。<br/>
                ご朝食:  8:00にご用意いたします。<br/><br/>
                ※8:30までにチェックアウトされる方には、7:30にご朝食のご用意が可能です。ご希望の場合は、事前にご連絡ください。

                <h2>アレルギー対応等について</h2>
                少人数のスタッフで運営している小さなペンションということもあり、万一のことを考えると安易に対応をすることは危険と考えておりますため、アレルギー除去食のご要望についてはお受けできません。申し訳ございませんが、ご理解の程よろしくお願いいたします。

                <h2>お風呂について</h2>
                １部屋のご予約ごとに、40分間ご利用いただける貸し切りの岩風呂のご用意がございます。岩風呂のご予約については、チェックインの際に、先着順でお受けしております。先にチェックインされたお客様のご予約状況により、ご希望のお時間にご予約いただけない場合がありますが、ご了承くださいますようお願いいたします。<br/><br/>
                ※シャワールーム、バスルームが備え付けられているお部屋にご宿泊のお客様も岩風呂をご利用いただけます。

                <h2>キャンセルについて</h2>
                お客様のご都合によるキャンセルについては、下記の通り、規定のキャンセル料金が発生いたします。<br/><br/>
                チェックイン当日のキャンセル : ご宿泊料金の100%<br/>
                前日および前々日のキャンセル : ご宿泊料金の 60%<br/>
                3日前から8日前のキャンセル : ご宿泊料金の 30%<br/>
                9日以前のキャンセル : 無料

                <h2>飲食物等のお持ち込みについて</h2>
                飲食物のお持込は、離乳食、アレルギー除去食を除いてお断りいたします。特にお持込をご希望されるお客様は、事前にご相談ください。また、盲導犬・聴導犬・介助犬を除く一般のペットの館内への同伴や、危険物のお持込は固くお断りいたします。
              </div>

            </main>

            <div className="footer">
              <div id="footerLogo">
                <img src="../images/funwarikon.png" alt="footerLogo" />
                <div>〒410-1231 静岡県 裾野市 須山 2255-3810</div>
                <div>☎ 055-998-1433</div>
                <div>https://funwarikon.com</div>
                <img src="../images/qr.png" alt="qr" id="qr"/>
              </div>

            </div>

          </div>
        </div>
      </div>
    );
  }
}


class ReservationSheet extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      ...props.state
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      ...nextProps.state
    })
  }

  nl2brJsx = (str) =>{
    let lines = [];
    let array = str.split("\n");
    for(let i in array){
      lines.push(<Fragment key={"lines" + i}>{array[i]}<br/></Fragment>);
    }
    return lines;
  }

  calculatePlanTotal = (plans, isJalan, jalanPaid, extraCharge, discount, jalanCoupon, jalanPoint, jalanSubsidy) => {
    let total = 0;

    if(jalanPaid === "yes"){
      return total;
    }

    plans.map(n => {
      total += (Number(n.unitPrice) * Number(n.amount))
      return true;
    })

    if(isJalan === "no"){
      total += Number(extraCharge);
      total -= Number(discount);
    }

    if(isJalan === "yes"){
      total -= Number(jalanCoupon);
      total -= Number(jalanPoint);
      total -= Number(jalanSubsidy);
    }


    return total;
  }

  calculateTaxTotal = (plans, isJalan, jalanPaid, extraCharge, discount, jalanCoupon, jalanPoint, jalanSubsidy, orders, taxRate) => {
    let tax = 0;

    if(isJalan === "no"){
      tax += Math.floor(this.calculatePlanTotal(plans, isJalan, jalanPaid, extraCharge, discount, jalanCoupon, jalanPoint, jalanSubsidy) * Number(taxRate))
    }

    if(isJalan === "yes"){
      tax += Math.floor(this.calculatePlanTotal(plans, isJalan, jalanPaid, extraCharge, discount, jalanCoupon, jalanPoint, jalanSubsidy) * (Number(taxRate)) / (1 + Number(taxRate)))
    }

    tax += Math.floor(this.calculateOrderOuterTaxTotal(orders) * Number(taxRate))

    tax += Math.floor(this.calculateOrderInnerTaxTotal(orders) * (Number(taxRate)) / (1 + Number(taxRate)))

    return tax;

  }

  calculateTotal = (plans, isJalan, jalanPaid, extraCharge, discount, jalanCoupon, jalanPoint, jalanSubsidy, orders, taxRate) => {
    let total = 0;

    if(isJalan === "no"){
      total += Math.floor(this.calculatePlanTotal(plans, isJalan, jalanPaid, extraCharge, discount, jalanCoupon, jalanPoint, jalanSubsidy) * (1 + Number(taxRate)))
    }

    if(isJalan === "yes"){
      total += this.calculatePlanTotal(plans, isJalan, jalanPaid, extraCharge, discount, jalanCoupon, jalanPoint, jalanSubsidy)
    }

    total += Math.floor(this.calculateOrderOuterTaxTotal(orders) * (1 + Number(taxRate)))

    total += this.calculateOrderInnerTaxTotal(orders)

    return total;

  }

  calculateOrderOuterTaxTotal = (orders) => {
    let total = 0;

    orders.map(n => {
      if(n.taxType === "税別"){
        total += Number(n.price) * Number(n.amount)
      }
      return true;
    })

    return total;
  }

  calculateOrderInnerTaxTotal = (orders,taxRate) => {
    let total = 0;

    orders.map(n => {
      if(n.taxType === "税込"){
        total += Number(n.price) * Number(n.amount)
      }
      return true;
    })

    return total;
  }

  getPrintRoomTypes = (rooms) => {
    let printRoomTypes = []

    if(
      rooms.some((n) => {
        if(roomTypes.twin.rooms.includes(n)){
          return true
        }
        return false
      })
    ){
      printRoomTypes.push(roomTypes.twin.name)
    }

    if(
      rooms.some((n) => {
        if(roomTypes.triple.rooms.includes(n)){
          return true
        }
        return false
      })
    ){
      printRoomTypes.push(roomTypes.triple.name)
    }

    if(
      rooms.some((n) => {
        if(roomTypes.quartette.rooms.includes(n)){
          return true
        }
        return false
      })
    ){
      printRoomTypes.push(roomTypes.quartette.name)
    }

    if(
      rooms.some((n) => {
        if(roomTypes.regular.rooms.includes(n)){
          return true
        }
        return false
      })
    ){
      printRoomTypes.push(roomTypes.regular.name)
    }

    if(
      rooms.some((n) => {
        if(roomTypes.cottage.rooms.includes(n)){
          return true
        }
        return false
      })
    ){
      printRoomTypes.push(roomTypes.cottage.name)
    }

    return printRoomTypes
  }

  render() {
    return (
      <div className="reservationSheet">
        <link rel="stylesheet" href="../css/ReservationSheet.css" />
        <section className="sheet">
            <div className="row_1">
                <h1 className="text-center">予約表</h1>
            </div>
            <div className="row_3">
                <div className="col_1">
                    <ul>
                        <li>
                            <h2 className="customer_name">宿泊者情報</h2>
                        </li>
                        <br/>
                        <li>{this.state.printCustomer.last_name_kana ? this.state.printCustomer.last_name_kana : ""} {this.state.printCustomer.first_name_kana ? this.state.printCustomer.first_name_kana : ""}</li>
                        <li className="name" >{this.state.printCustomer.last_name} {this.state.printCustomer.first_name} 様</li>
                        <br/>
                        <li>〒{this.state.printCustomer.post_num.substr(0,3)}-{this.state.printCustomer.post_num.substr(3,4)}</li>
                        <li>{this.state.printCustomer.address_prefectures} {this.state.printCustomer.address_city} {this.state.printCustomer.address_other}</li>
                        <li>{this.state.printCustomer.address_building ? this.state.printCustomer.address_building : ""}</li>
                        <br/>
                        <li>電話番号1: {this.state.printCustomer.tel ? this.state.printCustomer.tel : ""}</li>
                        <li>電話番号2: {this.state.printCustomer.tel2 ? this.state.printCustomer.tel2 : ""}</li>
                        <br/>
                        <li>mail: {this.state.printCustomer.email ? this.state.printCustomer.email : ""}</li>
                        <br/>
                        <li>備考: {this.state.printCustomer.customer_note ? this.nl2brJsx(this.state.printCustomer.customer_note) : ""}</li>
                    </ul>
                </div>
                <div className="col_2">
                  <ul>
                    <li>
                      <h2 className="customer_name">プラン情報</h2>
                    </li>
                    <br/>

                    ご宿泊日程　:　　{moment(this.state.printReservaion.date).format("YYYY年M月D日（ddd）")} から {this.state.printReservaion.date_num}泊
                    <br/>
                    {this.getPrintRoomTypes(this.state.printReservaion.input_rooms).map((m, i) => {
                      if(i === 0){
                        return(
                          <Fragment key={"notJalan" + i}>
                            お部屋タイプ　:　{m}
                          </Fragment>
                        )
                      }else{
                        return(
                          <Fragment><br/>
                            　　　　　　　　{m}
                          </Fragment>
                        )
                      }

                    })}

                    <br/>
                    <br/>
                    <table>
                      <thead>
                        <tr>
                          <th className="desc">ご予約内容</th>
                          <th>単価</th>
                          <th>数量</th>
                          <th>小計</th>
                        </tr>
                      </thead>

                      <tbody key={this.state.printReservaion.reservation_id}>

                        {this.state.printReservaion.plans.map((m,i) => {

                          return(
                            <tr key={"notJalan" + i}>
                              <td className="desc" style={{textAlign: "left"}}>{m.basePlan}ご宿泊料（{m.mealPlan === "無" ? "お食事無し" : m.mealPlan}・ベッド{m.bedPlan}）</td>
                              <td className="unit">￥{Number(m.unitPrice).toLocaleString()}</td>
                              <td className="qty">{m.amount}</td>
                              <td className="total">￥{(Number(m.unitPrice) * Number(m.amount)).toLocaleString()}</td>
                            </tr>
                          )

                        })}

                        {(() => {

                          if (this.state.printReservaion.extra_charge && this.state.printReservaion.discount){
                            return (
                              <Fragment>
                                <tr>
                                  <td className="desc"></td>
                                  <td className="unit"></td>
                                  <td className="qty"></td>
                                  <td className="total"></td>
                                </tr>
                                <tr>
                                  <td className="desc">その他サービス料</td>
                                  <td className="unit"></td>
                                  <td className="qty"></td>
                                  <td className="total">¥{Number(this.state.printReservaion.extra_charge).toLocaleString()}</td>
                                </tr>
                                <tr>
                                  <td className="desc">割引額</td>
                                  <td className="unit"></td>
                                  <td className="qty"></td>
                                  <td className="total">¥-{Number(this.state.printReservaion.discount).toLocaleString()}</td>
                                </tr>
                              </Fragment>
                            )
                          }

                          if (this.state.printReservaion.extra_charge){
                            return (
                              <Fragment>
                                <tr>
                                  <td className="desc"></td>
                                  <td className="unit"></td>
                                  <td className="qty"></td>
                                  <td className="total"></td>
                                </tr>
                                <tr>
                                  <td className="desc">その他サービス料</td>
                                  <td className="unit"></td>
                                  <td className="qty"></td>
                                  <td className="total">¥{Number(this.state.printReservaion.extra_charge).toLocaleString()}</td>
                                </tr>
                              </Fragment>
                            )
                          }

                          if (this.state.printReservaion.discount){
                            return (
                              <Fragment>
                                <tr>
                                  <td className="desc"></td>
                                  <td className="unit"></td>
                                  <td className="qty"></td>
                                  <td className="total"></td>
                                </tr>
                                <tr>
                                  <td className="desc">割引額</td>
                                  <td className="unit"></td>
                                  <td className="qty"></td>
                                  <td className="total">¥-{Number(this.state.printReservaion.discount).toLocaleString()}</td>
                                </tr>
                              </Fragment>
                            )
                          }
                         })()}

                        <tr>
                          <td colSpan="3" className="grand total">合計金額</td>
                          <td className="grand total">￥{this.calculatePlanTotal(this.state.printReservaion.plans, this.state.printReservaion.is_jalan, this.state.printReservaion.jalan_paid, this.state.printReservaion.extra_charge, this.state.printReservaion.discount, this.state.printReservaion.jalan_coupon, this.state.printReservaion.jalan_point, this.state.printReservaion.jalan_subsidy).toLocaleString()}</td>
                        </tr>

                      </tbody>
                    </table>

                    <br/>
                    備考: {this.state.printReservaion.plan_note ? this.nl2brJsx(this.state.printReservaion.plan_note) : ""}

                  </ul>
                </div>
              </div>
        </section>
      </div>
    );
  }
}


const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 300,
  },
  formControl: {
    margin: theme.spacing.unit
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  button: {
    margin: theme.spacing.unit,
  },
  PlasticBagCheckboxFormControl: {
    marginLeft: 30,
  },
});

let id = 0;
const createPlan = (basePlan, bedPlan, mealPlan, unitPrice, amount) => {
  id += 1;
  return { id, basePlan, bedPlan, mealPlan, unitPrice, amount };
}

const initialState = {
  activeReservations: [],
  canceledTodoReservations: [],
  reservationOpen: false,
  customerOpen: false,
  cancelOpen: false,
  printOpen: false,
  printReservaionSheetOpen: false,
  printReservaion: {
    reservation_id: "",
    date: "",
    date_num: "",
    input_rooms: [],
    plans: [],

  },
  printCustomer: {
    customer_id: "",
    post_num: "",
    address_prefectures: "",
    address_city: "",
    address_other: "",
    address_building: "",
    last_name: "",
    first_name: "",
  },
  canceledCompleteOpen: false,
  confirmCancelReservationId: "",
  confirmReservationReservationId: "",
  confirmCustomerReservationId: "",
  confirmCustomerCustomerId: "",
  confirmCanceledCompleteReservationId: "",
  date: moment().format("YYYY-MM-DD"),
  dateNum: "1",
  inputRooms: [],
  rooms:[],
  roomError: false,
  inputBasePlan:"",
  inputBedPlan: "",
  inputMealPlan:"",
  inputUnitPrice: "",
  inputAmount: "",
  plans:[],
  planError: "none",
  isJalan: "no",
  jalanPaid: "no",
  extraCharge:"",
  discount:"",
  gotoDiscount: "no",
  jalanNumber:"",
  jalanPoint:"",
  jalanCoupon:"",
  jalanSubsidy:"",
  taxRate: "",
  planShortageError:"none",
  planNegativeError:"none",
  babyChairs: "0",
  joinBed: "0",
  plasticBag: "no",
  familyMemberOpen: false,
  scroll: "paper",
  babyM: "",
  babyW: "",
  kindergartenM: "",
  kindergartenW: "",
  elementarySchoolLowM: "",
  elementarySchoolLowW: "",
  elementarySchoolMiddleM: "",
  elementarySchoolMiddleW: "",
  elementarySchoolHighM: "",
  elementarySchoolHighW: "",
  juniorHighSchoolM: "",
  juniorHighSchoolW: "",
  highSchoolM: "",
  highSchoolW: "",
  universityM: "",
  universityW: "",
  twentiesM: "",
  twentiesW: "",
  thirtiesM: "",
  thirtiesW: "",
  fortiesM: "",
  fortiesW: "",
  fiftiesM: "",
  fiftiesW: "",
  sixtiesM: "",
  sixtiesW: "",
  overSeventiesM: "",
  overSeventiesW: "",
  transportation: "",
  planNote: "",
  isRepeatCustomer: "no",
  repeatCustomerId: "",
  searchCustomersResult: [],
  repeatCustomerOpen: false,
  lastNameKanaSC: "",
  firstNameKanaSC: "",
  telSC: "",
  emailSC: "",
  lastName: "",
  lastNameOnFocus: "no",
  firstName: "",
  lastNameKana: "",
  lastNameKanaOnFocus : "no",
  lastNameList: [],
  firstNameKana: "",
  tel: "",
  tel2: "",
  email: "",
  postNum:"",
  addressPrefectures:"",
  addressCity:"",
  addressOther:"",
  addressBuilding:"",
  customerNote:"",
  targetReservationId: "",
  moveToReservation: "",
};

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class ReservationManage extends Component {

  constructor(props) {
    super(props);
    this.state = initialState;
    this.authApi = new AuthService();
  }

  compare = (a, b) => {
    const dateA = a.date;
    const dateB = b.date;

    let comparison = 0;
    if (dateA > dateB) {
      comparison = 1;
    } else if (dateA < dateB) {
      comparison = -1;
    }
    return comparison;
  }

  componentWillMount(){

    this.authApi.isLogin()
    .then(
      (login) => {
        if(!login){
          this.props.history.push('/login');
        }
      }
    );

    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/search-reservations-for-manage'; //replace this with the path you have configured on your API

    API.get(apiName, path).then(response => {
      console.log(response);
      response.activeReservations.sort(this.compare);
      response.canceledTodoReservations.sort(this.compare);
      this.setState({
        activeReservations : response.activeReservations,
        canceledTodoReservations : response.canceledTodoReservations,
      },() => {
        for(let i in this.state.activeReservations){
          this.setState({
            [this.state.activeReservations[i].reservation_id + "S1"]: this.state.activeReservations[i].status === "active_reserved_todo" ? "no" : "yes",
            [this.state.activeReservations[i].reservation_id + "C2"]: this.state.activeReservations[i].information_status === "no_need" ? "yes" : "no",
            [this.state.activeReservations[i].reservation_id + "S2"]: this.state.activeReservations[i].information_status === "done" ? "yes" : "no",
          })
        }
      });
    }).catch(error => {
      console.log(error);
    })

    //カレンダーから飛んでいた時に、メニューの選択中のハイライトを制御するためにある？？
    this.props.setPath();
  }

  componentDidMount(){

    const { location } = this.props

    if(location.search !== ""){
      let queryArg = {};
      let pair=location.search.substring(1).split('&');
      for(var i=0;pair[i];i++) {
          var kv = pair[i].split('=');
          queryArg[kv[0]]=kv[1];
      }

      this.setState({
        targetReservationId: queryArg.reservationId,
      })
    }
  }


  componentDidUpdate(){
    const { location } = this.props

    if(location.search !== ""){
      let queryArg = {};
      let pair=location.search.substring(1).split('&');
      for(var i=0;pair[i];i++) {
          var kv = pair[i].split('=');
          queryArg[kv[0]]=kv[1];
      }

      console.log("queryArg: ", queryArg)

      if(this["ref" + queryArg.reservationId]){
        if(this.state.moveToReservation !== "done"){
          console.log("move to reservation")
          this["ref" + queryArg.reservationId].scrollIntoView(false);
          this.setState({
            moveToReservation: "done"
          })
        }
      }
    }
  }

  handleChangeSwitch = (event, key) => {
    let check = event.target.checked;
    console.log("event.target.checked: ", check);
    console.log("key: ", key);

    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/update-active-reservations'; //replace this with the path you have configured on your API

    let reservationId = key.slice(0, -2);

    let body = {
      reservationId : reservationId,
    };

    let keyType = key.slice(-2);

    if(keyType === "S1"){
      if(check === true){
        body.status = "active_reserved_complete"
      }else{
        body.status = "active_reserved_todo"
      }
    }

    if(keyType === "C2"){
      if(check === true){
        body.informationStatus = "no_need"
      }else{
        body.informationStatus = "todo"
      }
    }

    if(keyType === "S2"){
      if(check === true){
        body.informationStatus = "done"
      }else{
        body.informationStatus = "todo"
      }
    }

    let myInit = {
        body: body, // replace this with attributes you need
    }

    const { enqueueSnackbar } = this.props;

    API.post(apiName, path, myInit).then(response => {
      console.log(response)
      this.setState({
        [key] : check ? "yes" : "no"
      });
      enqueueSnackbar(response.message, {variant : 'success'});
    }).catch(error => {
      console.log(error)
      if(error.message){
        enqueueSnackbar(error.message, {variant : 'error'})
      }else{
        enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
      }
    });
  }

  handleReservationOpen = (reservationId) => {
    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/search-reservation'; //replace this with the path you have configured on your API

    let body = {
      reservationId : reservationId,
    };

    let myInit = {
        body: body, // replace this with attributes you need
    }

    const { enqueueSnackbar } = this.props;

    API.post(apiName, path, myInit).then(response => {
      console.log(response)

      this.setState({
        confirmReservationReservationId : reservationId,
        reservationOpen: true,
        date: moment().format(response.reservation.date),
        dateNum: response.reservation.date_num,
        inputRooms: response.reservation.input_rooms,
        plans: response.reservation.plans,
        isJalan: response.reservation.is_jalan,
        jalanPaid: response.reservation.jalan_paid ? response.reservation.jalan_paid : this.state.jalanPaid,
        extraCharge: response.reservation.extra_charge ? response.reservation.extra_charge : this.state.extraCharge,
        discount: response.reservation.discount ? response.reservation.discount : this.state.discount,
        gotoDiscount: response.reservation.goto_discount ? response.reservation.goto_discount : this.state.gotoDiscount,
        jalanNumber: response.reservation.jalan_number ? response.reservation.jalan_number : this.state.jalanNumber,
        jalanPoint: response.reservation.jalan_point ? response.reservation.jalan_point : this.state.jalanPoint,
        jalanCoupon: response.reservation.jalan_coupon ? response.reservation.jalan_coupon : this.state.jalanCoupon,
        jalanSubsidy: response.reservation.jalan_subsidy ? response.reservation.jalan_subsidy : this.state.jalanSubsidy,
        taxRate: response.reservation.tax_rate,
        babyChairs: response.reservation.baby_chairs,
        joinBed: response.reservation.join_bed,
        plasticBag: response.reservation.plastic_bag,
        babyM: response.reservation.baby_m ? response.reservation.baby_m : this.state.babyM,
        babyW: response.reservation.baby_w ? response.reservation.baby_w : this.state.babyW,
        kindergartenM: response.reservation.kindergarten_m ? response.reservation.kindergarten_m : this.state.kindergartenM,
        kindergartenW: response.reservation.kindergarten_w ? response.reservation.kindergarten_w : this.state.kindergartenW,
        elementarySchoolLowM: response.reservation.elementary_school_low_m ? response.reservation.elementary_school_low_m : this.state.elementarySchoolLowM,
        elementarySchoolLowW: response.reservation.elementary_school_low_w ? response.reservation.elementary_school_low_w : this.state.elementarySchoolLowW,
        elementarySchoolMiddleM: response.reservation.elementary_school_middle_m ? response.reservation.elementary_school_middle_m : this.state.elementarySchoolMiddleM,
        elementarySchoolMiddleW: response.reservation.elementary_school_middle_w ? response.reservation.elementary_school_middle_w : this.state.elementarySchoolMiddleW,
        elementarySchoolHighM: response.reservation.elementary_school_high_m ? response.reservation.elementary_school_high_m : this.state.elementarySchoolHighW,
        elementarySchoolHighW: response.reservation.elementary_school_high_w ? response.reservation.elementary_school_high_w : this.state.elementarySchoolHighW,
        juniorHighSchoolM: response.reservation.junior_high_school_m ? response.reservation.junior_high_school_m : this.state.juniorHighSchoolM,
        juniorHighSchoolW: response.reservation.junior_high_school_w ? response.reservation.junior_high_school_w : this.state.juniorHighSchoolW,
        highSchoolM: response.reservation.high_school_m ? response.reservation.high_school_m : this.state.highSchoolM,
        highSchoolW: response.reservation.high_school_w ? response.reservation.high_school_w : this.state.highSchoolW,
        universityM: response.reservation.university_m ? response.reservation.university_m : this.state.universityM,
        universityW: response.reservation.university_w ? response.reservation.university_w : this.state.universityW,
        twentiesM: response.reservation.twenties_m ? response.reservation.twenties_m : this.state.twentiesM,
        twentiesW: response.reservation.twenties_w ? response.reservation.twenties_w : this.state.twentiesW,
        thirtiesM: response.reservation.thirties_m ? response.reservation.thirties_m : this.state.thirtiesM,
        thirtiesW: response.reservation.thirties_w ? response.reservation.thirties_w : this.state.thirtiesW,
        fortiesM: response.reservation.forties_m ? response.reservation.forties_m : this.state.fortiesM,
        fortiesW: response.reservation.forties_w ? response.reservation.forties_w : this.state.fortiesW,
        fiftiesM: response.reservation.fifties_m ? response.reservation.fifties_m : this.state.fiftiesM,
        fiftiesW: response.reservation.fifties_w ? response.reservation.fifties_w : this.state.fiftiesW,
        sixtiesM: response.reservation.sixties_m ? response.reservation.sixties_m : this.state.sixtiesM,
        sixtiesW: response.reservation.sixties_w ? response.reservation.sixties_w : this.state.sixtiesW,
        overSeventiesM: response.reservation.over_seventies_m ? response.reservation.over_seventies_m : this.state.overSeventiesM,
        overSeventiesW: response.reservation.over_seventies_w ? response.reservation.over_seventies_w : this.state.overSeventiesW,
        transportation: response.reservation.transportation ? response.reservation.transportation : this.state.transportation,
        planNote: response.reservation.plan_note ? response.reservation.plan_note : this.state.planNote,
      })

    }).catch(error => {
      console.log(error)
      if(error.message){
        enqueueSnackbar(error.message, {variant : 'error'})
      }else{
        enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
      }
    });

  }

  handleCustomerOpen = (customerId, reservationId) => {
    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/search-customer'; //replace this with the path you have configured on your API

    let body = {
      customerId: customerId
    };

    let myInit = {
      body: body, // replace this with attributes you need
    }

    const { enqueueSnackbar } = this.props;

    API.post(apiName, path, myInit).then(response => {
      console.log(response)

      this.setState({
        confirmCustomerReservationId : reservationId,
        confirmCustomerCustomerId: customerId,
        customerOpen: true,

        isRepeatCustomer: response.customer.reservation_id_history.length > 1 ? "yes" : "no",
        repeatCustomerId: response.customer.reservation_id_history.length > 1 ? customerId : "",

        lastName: response.customer.last_name,
        firstName: response.customer.first_name,
        lastNameKana: response.customer.last_name_kana,
        firstNameKana: response.customer.first_name_kana,
        tel: response.customer.tel ? response.customer.tel : this.state.tel,
        tel2: response.customer.tel2 ? response.customer.tel2 : this.state.tel2,
        email: response.customer.email ? response.customer.email : this.state.email,
        postNum: response.customer.post_num ? response.customer.post_num : this.state.postNum,
        addressPrefectures: response.customer.address_prefectures ? response.customer.address_prefectures : this.state.addressPrefectures,
        addressCity: response.customer.address_city ? response.customer.address_city : this.state.addressCity,
        addressOther: response.customer.address_other ? response.customer.address_other : this.state.addressOther,
        addressBuilding: response.customer.address_building ? response.customer.address_building : this.state.addressBuilding,
        customerNote: response.customer.customer_note ? response.customer.customer_note : this.state.customerNote,
      })

    }).catch(error => {
      console.log(error)
      if(error.message){
        enqueueSnackbar(error.message, {variant : 'error'})
      }else{
        enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
      }
    });
  }

  handleCancelOpen = (reservationId) => {
    this.setState({
      confirmCancelReservationId: reservationId,
      cancelOpen: true
    })
  }

  handlePrintOpen = (reservationId, customerId) => {

    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/search-reservation'; //replace this with the path you have configured on your API

    let body = {
      reservationId : reservationId,
    };

    let myInit = {
        body: body, // replace this with attributes you need
    }

    const { enqueueSnackbar } = this.props;

    API.post(apiName, path, myInit).then(reservationResponse => {
      console.log(reservationResponse)

      let path = '/search-customer'; //replace this with the path you have configured on your API

      let body = {
        customerId: customerId
      };

      let myInit = {
        body: body, // replace this with attributes you need
      }

      API.post(apiName, path, myInit).then(customerResponse => {
        console.log(customerResponse)

        if(!customerResponse.customer.post_num){
          enqueueSnackbar('ご案内の印刷前に、郵便番号を登録してください', {variant : 'warning'})
        }else{
          this.setState({
            printReservaion : reservationResponse.reservation,
            printCustomer : customerResponse.customer,
            printOpen: true
          })
        }
      }).catch(error => {
        console.log(error)
        if(error.message){
          enqueueSnackbar(error.message, {variant : 'error'})
        }else{
          enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
        }
      });
    }).catch(error => {
      console.log(error)
      if(error.message){
        enqueueSnackbar(error.message, {variant : 'error'})
      }else{
        enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
      }
    });
  }

  handlePrintReservationSheetOpen = (reservationId, customerId) => {

    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/search-reservation'; //replace this with the path you have configured on your API

    let body = {
      reservationId : reservationId,
    };

    let myInit = {
        body: body, // replace this with attributes you need
    }

    const { enqueueSnackbar } = this.props;

    API.post(apiName, path, myInit).then(reservationResponse => {
      console.log(reservationResponse)

      let path = '/search-customer'; //replace this with the path you have configured on your API

      let body = {
        customerId: customerId
      };

      let myInit = {
        body: body, // replace this with attributes you need
      }

      API.post(apiName, path, myInit).then(customerResponse => {
        console.log(customerResponse)

        this.setState({
          printReservaion : reservationResponse.reservation,
          printCustomer : customerResponse.customer,
          printReservaionSheetOpen: true
        })

      }).catch(error => {
        console.log(error)
        if(error.message){
          enqueueSnackbar(error.message, {variant : 'error'})
        }else{
          enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
        }
      });
    }).catch(error => {
      console.log(error)
      if(error.message){
        enqueueSnackbar(error.message, {variant : 'error'})
      }else{
        enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
      }
    });
  }

  handleClose = (key) => {
    this.setState({
      [key]: false,
      confirmCancelReservationId: "",
      confirmReservationReservationId: "",
      confirmCustomerReservationId: "",
      confirmCustomerCustomerId: "",
      confirmCanceledCompleteReservationId: "",
      date: "",
      dateNum: "1",
      inputRooms: [],
      plans:[],
      isJalan: "no",
      jalanPaid: "no",
      extraCharge:"",
      discount:"",
      gotoDiscount: "no",
      jalanNumber:"",
      jalanPoint:"",
      jalanCoupon:"",
      jalanSubsidy:"",
      taxRate: "",
      babyChairs: "0",
      joinBed: "0",
      plasticBag: "no",
      babyM: "",
      babyW: "",
      kindergartenM: "",
      kindergartenW: "",
      elementarySchoolLowM: "",
      elementarySchoolLowW: "",
      elementarySchoolMiddleM: "",
      elementarySchoolMiddleW: "",
      elementarySchoolHighM: "",
      elementarySchoolHighW: "",
      juniorHighSchoolM: "",
      juniorHighSchoolW: "",
      highSchoolM: "",
      highSchoolW: "",
      universityM: "",
      universityW: "",
      twentiesM: "",
      twentiesW: "",
      thirtiesM: "",
      thirtiesW: "",
      fortiesM: "",
      fortiesW: "",
      fiftiesM: "",
      fiftiesW: "",
      sixtiesM: "",
      sixtiesW: "",
      overSeventiesM: "",
      overSeventiesW: "",
      transportation: "",
      planNote: "",
      isRepeatCustomer: "no",
      repeatCustomerId: "",
      searchCustomersResult: [],
      repeatCustomerOpen: false,
      lastNameKanaSC: "",
      firstNameKanaSC: "",
      telSC: "",
      emailSC: "",
      lastName: "",
      firstName: "",
      lastNameKana: "",
      lastNameList: [],
      firstNameKana: "",
      tel: "",
      tel2: "",
      email: "",
      postNum:"",
      addressPrefectures:"",
      addressCity:"",
      addressOther:"",
      addressBuilding:"",
      customerNote:"",
    });
  };



  //予約更新用関数
  updateReservatiion = (event) => {
    console.log("event", event)

    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/update-reservation'; //replace this with the path you have configured on your API

    let body = {
      ...this.state
    };

    let myInit = {
      body: body, // replace this with attributes you need
    }

    const { enqueueSnackbar } = this.props;

    API.post(apiName, path, myInit).then(response => {
      console.log(response)

      let confirmReservationReservationId = this.state.confirmReservationReservationId;

      let reservationItemBefore = this.state.activeReservations.find((reservationItem) => {
          return (reservationItem.reservation_id === confirmReservationReservationId);
      });

      let activeReservationsAfter = this.state.activeReservations;
      let activeReservationsAfterNum;

      activeReservationsAfter.some(function(reservationItem, i){
        if (reservationItem.reservation_id === confirmReservationReservationId){
          activeReservationsAfterNum = i;
          activeReservationsAfter.splice(i,1);
          return true;
        }
        return false;
      });

      let reservationItemAfter = {
        customer_id: reservationItemBefore.customer_id,
        date: this.state.date,
        first_name: reservationItemBefore.first_name,
        first_name_kana: reservationItemBefore.first_name_kana,
        information_status: reservationItemBefore.information_status,
        input_rooms: this.state.inputRooms,
        last_name: reservationItemBefore.last_name,
        last_name_kana: reservationItemBefore.last_name_kana,
        reservation_id: reservationItemBefore.reservation_id,
        status: reservationItemBefore.status,
        is_jalan: this.state.isJalan,
      }

      activeReservationsAfter.splice(activeReservationsAfterNum , 0 , reservationItemAfter);

      this.setState({
        reservationOpen: false,
        confirmReservationReservationId: "",
        activeReservations : activeReservationsAfter,
      });

      enqueueSnackbar(response.message, {variant : 'success'});

    }).catch(error => {
      console.log(error)
      if(error.message){
        enqueueSnackbar(error.message, {variant : 'error'})
      }else{
        enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
      }
    });


  }

  handleChange = (event, key) => {

    this.setState({
      [key] : event.target.value
    }, () => {
      if(key === "inputBasePlan" && this.state.inputBasePlan === "素泊り"){
        this.setState({
          inputMealPlan: "無"
        })
      }

      if(key === "date"){

        let taxChangeDate = moment(taxChangeBorder)
        let date = moment (this.state.date)
        let taxRate = taxRateBefore20191001;

        if(date.isAfter(taxChangeDate)){
          taxRate = taxRateAfter20191001
        }

        this.setState({
          taxRate: taxRate
        })
      }

      if(key === "inputBasePlan" && this.state.inputBasePlan !== "" && this.state.inputBasePlan !== "素泊り"){

        let inputBedPlan
        let inputMealPlan
        let inputAmount

        if(this.state.inputBasePlan === "大人"){
          inputBedPlan = "有"
          inputMealPlan ="2食付"
          inputAmount = 2
        }
        if(this.state.inputBasePlan === "ジュニア"){
          inputBedPlan = "有"
          inputMealPlan = "2食付"
          inputAmount = 1
        }
        if(this.state.inputBasePlan === "キッズ"){
          inputBedPlan = "無"
          inputMealPlan = "2食付"
          inputAmount = 1
        }
        this.setState({
          inputBedPlan: inputBedPlan,
          inputMealPlan: inputMealPlan,
          inputAmount: inputAmount
        },() => {
          if(this.state.rooms.length !== 0){
            this.setState({
              inputUnitPrice: this.calculatePrice()
            })
          }
        })
      }

      if(key === "inputRooms"){
        let roomLength = this.state.inputRooms.length;
        if(roomLength === 0){
          this.setState({
            rooms:[],
            roomError: true
          })
        }else{
          let rooms = []
          this.state.inputRooms.forEach(value =>{
            let room = roomPlans.filter((item) => {
              return item.name === value;
            });
            rooms.push(room[0])
          })
          this.setState({
            rooms:rooms,
            roomError: false
          },() => {
            if(
                this.state.inputBasePlan !== "" &&
                this.state.inputBedPlan !== ""
            ){
              this.setState({
                inputUnitPrice: this.calculatePrice()
              })
            }
          })
        }
      }

      if(
          (
            key === "inputBedPlan" ||
            key === "inputMealPlan"
          )
          &&
          (
            this.state.rooms.length !== 0 &&
            this.state.inputBasePlan !== "" &&
            this.state.inputBedPlan !== ""
          )
      ){
        this.setState({
          inputUnitPrice: this.calculatePrice()
        })
      }

    });
  }

  handleChangeCheck = (event, key) => {
    if(event.target.checked){
      this.setState({ [key] : "yes" });
    }else{
      this.setState({ [key] : "no" });
    }

    if(key === "isJalan"){
      if(event.target.checked){
        this.setState({
           extraCharge : "",
           discount : "",
           gotoDiscount : "no"
        });
      }else{
        this.setState({
          jalanPaid: "no",
          jalanNumber:"",
          jalanPoint: "",
          jalanCoupon: "",
          jalanSubsidy: ""
        });
      }
    }

    if(key === "isRepeatCustomer"){
      if(!event.target.checked){
        this.setState({
          repeatCustomerId : ""
        });
      }
    }

  }


  doSearch = (event, key) => {
    let value = event.target.value; // this is the search text

    this.setState({
      [key]: value
    })

    if(this.timeout) clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      if(key === "lastNameKana"){
        this.getLastName(value)
        this.handleSearchCustomers()
      }

      if(key === "postNum"){
        value = value.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => {
          return String.fromCharCode(s.charCodeAt(0) - 65248);
        });
        this.getAddress(value)
      }
    }, 1000);
  }

  changeChar = (event, key) => {
    let value = event.target.value; // this is the search text

    value = value.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => {
      return String.fromCharCode(s.charCodeAt(0) - 65248);
    });

    this.setState({
      [key]: value
    })
  }

  handleAddPlan = () => {
    if(
      !this.state.inputBasePlan  ||
      !this.state.inputBedPlan  ||
      (this.state.inputBasePlan !== "素泊り" && !this.state.inputMealPlan )  ||
      !this.state.inputUnitPrice ||
      !this.state.inputAmount
    ){
      this.setState({
        planShortageError: ""
      })
    }else{
      if(Number(this.state.inputUnitPrice) >= 1 && Number(this.state.inputAmount) >= 1){
        let plans = this.state.plans
        plans.push(createPlan(
          this.state.inputBasePlan,
          this.state.inputBedPlan,
          this.state.inputMealPlan,
          this.state.inputUnitPrice,
          this.state.inputAmount
        ))
        this.setState({
          plans: plans,
          planShortageError:"none",
          planNegativeError:"none",
          planError: "none"
        },() => {
          this.setState({
            inputBasePlan:"",
            inputBedPlan:"",
            inputMealPlan:"",
            inputUnitPrice: "",
            inputAmount: ""
          });
        });

        if(this.state.inputBedPlan === "無"){
          this.setState({
            joinBed : Number(this.state.joinBed) + Number(this.state.inputAmount)
          });
        }

      }else{
        this.setState({
          planNegativeError: ""
        })
      }
    }
  }

  handleDeletePlan = (id) => {
    let plans = this.state.plans

    const newPlans = plans.filter((item) => {
      return item.id !== id;
    });

    let joinBed = 0

    if(newPlans.length !== 0){
      newPlans.forEach((item) => {
        if(item.bedPlan === "無"){
          joinBed += Number(item.amount)
        }
      })
    }
    this.setState({
      plans: newPlans,
      joinBed: joinBed
    })

  }

  getTotalAmount = () => {
    let totalAmount = 0

    this.state.plans.forEach((item) => {
      totalAmount += Number(item.amount)
    })

    return totalAmount

  }

  calculatePrice = () =>{
    let price = 0

    price += Number(this.state.rooms[0].basePrice[this.state.inputBasePlan])
    if(this.state.inputBedPlan === "無"){
      price -= bedPrice
    }

    if(this.state.inputMealPlan === "夕食付"){
      if(this.state.inputBasePlan === "大人"){
        price -= mealPrice.breakfast.adult
      }

      if(this.state.inputBasePlan === "ジュニア"){
        price -= mealPrice.breakfast.junior
      }

      if(this.state.inputBasePlan === "キッズ"){
        price -= mealPrice.breakfast.kids
      }
    }

    if(this.state.inputMealPlan === "朝食付"){
      if(this.state.inputBasePlan === "大人"){
        price -= mealPrice.dinner.adult
      }

      if(this.state.inputBasePlan === "ジュニア"){
        price -= mealPrice.dinner.junior
      }

      if(this.state.inputBasePlan === "キッズ"){
        price -= mealPrice.dinner.kids
      }
    }

    return price
  }

  getTotalPrice = () => {
    let totalPrice = 0

    this.state.plans.forEach((item) => {
      totalPrice += Number(item.unitPrice) * Number(item.amount)
    })

    return totalPrice

  }

  getAddress = (postNum) => {

    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/address'; //replace this with the path you have configured on your API
    const myInit = { // OPTIONAL
      queryStringParameters: {  // OPTIONAL
        zipcode : postNum
      },
    };

    API.get(apiName, path, myInit).then(response => {
      if(response.status === 200){
        console.log(response.results[0]);

        this.setState({
          addressPrefectures: response.results[0].address1,
          addressCity: response.results[0].address2,
          addressOther: response.results[0].address3
        })
      }else{
        console.log(response.message)
      }
    }).catch(error => {
      console.log(error);
    })
  }

  getLastName = (lastNameKana) => {

    const kanaToHira = (str) => {
        return str.replace(/[\u30a1-\u30f6]/g, function(match) {
            var chr = match.charCodeAt(0) - 0x60;
            return String.fromCharCode(chr);
        });
    }

    const isZenKatakana = (str) =>{
      str = (str==null)?"":str;
      if(str.match(/^[ァ-ンヴー　]*$/)){    //"ー"の後ろの文字は全角スペースです。
        return true;
      }else{
        return false;
      }
    }

    let that = this;
    let keyword = lastNameKana
    let lastNameList = []

    if(isZenKatakana(keyword) && keyword && keyword.length > 1){
      console.log('Searching Last Name. Page: 1')
      keyword = kanaToHira(lastNameKana)
      axios.get('https://myoji-yurai.net/resultList.htm', {
        params: {
          kind : "読み方で",
          keyword: keyword,
        }
      })
      .then((response) => {
        try {
          const $ = cheerio.load(response.data)

          $('#content > div > table > tbody tr').each((i,element)=>{
            let lastNameKana =element.children[1].children[1].children[0].data
            let lastName = element.children[1].children[0].children[0].data

            if (
              lastNameKana.indexOf('(' + keyword + ')') !== -1 ||
              lastNameKana.indexOf(',' + keyword + ',') !== -1 ||
              lastNameKana.indexOf('(' + keyword + ',') !== -1 ||
              lastNameKana.indexOf(',' + keyword + ')') !== -1 ||
              lastNameKana.indexOf('…') !== -1
            ){
              lastNameList.push(lastName)
            }
          })
          that.setState({
            lastNameList: lastNameList,
          })

          const getLastNameMore = (page) => {
            page += 1
            console.log('Searching Last Name. Page: ' + page)
            axios.get('https://myoji-yurai.net/resultList.htm', {
              params: {
                kind : "読み方で",
                keyword: keyword,
                page: page
              }
            }).then((response) =>{
              try {
                const $ = cheerio.load(response.data)
                $('#content > div > table > tbody tr').each((i,element)=>{
                  let lastNameKana =element.children[1].children[1].children[0].data
                  let lastName = element.children[1].children[0].children[0].data

                  if (
                    lastNameKana.indexOf('(' + keyword + ')') !== -1 ||
                    lastNameKana.indexOf(',' + keyword + ',') !== -1 ||
                    lastNameKana.indexOf('(' + keyword + ',') !== -1 ||
                    lastNameKana.indexOf(',' + keyword + ')') !== -1 ||
                    lastNameKana.indexOf('…') !== -1
                  ){
                    lastNameList.push(lastName)
                  }
                })
                that.setState({
                  lastNameList: lastNameList,
                })

                length = $("a:contains('次ページ')").length
                if(length !== 0){
                  getLastNameMore(page)
                }else{
                  console.log('Last Name Search done.')
                }

              }catch(e){
                console.error(e)
              }
            })
          }

          let length = $("a:contains('次ページ')").length
          let page = 1

          if(length > 0){
            getLastNameMore(page)
          }else{
            console.log('Last Name Search done.')
          }

        }catch(e){
          console.error(e)
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    }else{
      console.log("not Zenkakukatakana")
    }
  }

  handleClickOpenDialog = (scroll,name) =>{
    this.setState({ [name]: true, scroll });

    if(name === "repeatCustomerOpen"){
      this.setState({ searchCustomersResult: [] });
    }
  }

  handleCloseDialog = name => {
    this.setState({ [name]: false });
  }

  //ここまで予約変雇用関数

  //顧客変更用関数

  updateCustomer = (event) => {
    console.log("event", event)

    this.setState({
      lastNameList: [],
      searchCustomersResult:[]
    },() => {
      let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
      let path = '/update-customer'; //replace this with the path you have configured on your API
      let myInit = {
        body: this.state, // replace this with attributes you need
      }

      const { enqueueSnackbar } = this.props;

      API.post(apiName, path, myInit).then(response => {
        console.log(response)

        let confirmCustomerReservationId = this.state.confirmCustomerReservationId;

        let reservationItemBefore = this.state.activeReservations.find((reservationItem) => {
            return (reservationItem.reservation_id === confirmCustomerReservationId);
        });

        let activeReservationsAfter = this.state.activeReservations;
        let activeReservationsAfterNum;

        activeReservationsAfter.some(function(reservationItem, i){
          if (reservationItem.reservation_id === confirmCustomerReservationId){
            activeReservationsAfterNum = i;
            activeReservationsAfter.splice(i,1);
            return true;
          }
          return false;
        });

        let reservationItemAfter = {
          customer_id: response.customer_id, //customer_idが変わる可能性ありのため
          date: reservationItemBefore.date,
          first_name: this.state.firstName,
          first_name_kana: this.state.firstNameKana,
          information_status: reservationItemBefore.information_status,
          input_rooms: reservationItemBefore.input_rooms,
          is_jalan: reservationItemBefore.is_jalan,
          last_name: this.state.lastName,
          last_name_kana: this.state.lastNameKana,
          reservation_id: reservationItemBefore.reservation_id,
          status: reservationItemBefore.status,
        }

        activeReservationsAfter.splice(activeReservationsAfterNum , 0 , reservationItemAfter);

        this.setState({
          customerOpen: false,
          confirmCustomerReservationId: "",
          confirmCustomerCustomerId: "",
          activeReservations : activeReservationsAfter,
        });

        enqueueSnackbar(response.message, {variant : 'success'});

      }).catch(error => {
        console.log(error)
        if(error.message){
          enqueueSnackbar(error.message, {variant : 'error'})
        }else{
          enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
        }
      });
    })





  }


  handleSearchCustomers = () => {
    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/search-customers'; //replace this with the path you have configured on your API
    let myInit = {
        body: {
          lastNameKanaSC: this.state.lastNameKanaSC ? this.state.lastNameKanaSC : this.state.lastNameKana,
          firstNameKanaSC: this.state.firstNameKanaSC,
          telSC: this.state.telSC,
          emailSC: this.state.emailSC,
        }
    }

    const { enqueueSnackbar } = this.props;

    API.post(apiName, path, myInit).then(response => {
      console.log(response)

      let searchCustomersResult = response.customers.filter((customer) => {
        if(customer.customer_id !== this.state.confirmCustomerCustomerId){return true}
        return false
      })

      this.setState({
        searchCustomersResult: searchCustomersResult
      });
      if(searchCustomersResult.length > 0){
        enqueueSnackbar(searchCustomersResult.length + '件が該当しました。', {variant : 'success'});
      }else{
        enqueueSnackbar('該当する顧客がいません。', {variant : 'warning'});
      }

    }).catch(error => {
      console.log(error)
      if(error.message){
        enqueueSnackbar(error.message, {variant : 'error'})
      }else{
        enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
      }
    })
  }

  setRepeatCustomer = (customerId) => {
    console.log("repeatCustomerId: ", customerId)

    const repeatCustomer = this.state.searchCustomersResult.find((customer) => {
      return (customer.customer_id === customerId);
    });

    this.setState({
      isRepeatCustomer: "yes",
      repeatCustomerId: customerId,
      repeatCustomerOpen: false,
      lastNameKanaSC: "",
      firstNameKanaSC: "",
      telSC: "",
      emailSC: "",
      lastName: repeatCustomer.last_name,
      firstName: repeatCustomer.first_name,
      lastNameKana: repeatCustomer.last_name_kana,
      firstNameKana: repeatCustomer.first_name_kana,
      tel: repeatCustomer.tel,
      tel2: repeatCustomer.tel2 ? repeatCustomer.tel2 : "",
      email: repeatCustomer.email ? repeatCustomer.email : "",
      postNum: repeatCustomer.post_num ? repeatCustomer.post_num : "",
      addressPrefectures: repeatCustomer.address_prefectures,
      addressCity: repeatCustomer.address_city,
      addressOther: repeatCustomer.address_other ? repeatCustomer.address_other : "",
      addressBuilding: repeatCustomer.address_building ? repeatCustomer.address_building : "",
      customerNote: repeatCustomer.customer_note ? repeatCustomer.customer_note : "",
    });
  }

  nl2brJsx = (str) =>{
    let lines = [];
    let array = str.split("\n");
    for(let i in array){
      lines.push(<Fragment key={"lines" + i}>{array[i]}<br/></Fragment>);
    }
    return lines;
  }


  //顧客変更用関数ここまで

  //予約キョンセル用関数


  cancelReservation = () => {
    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/cancel-reservation'; //replace this with the path you have configured on your API

    let body = {
      reservationId : this.state.confirmCancelReservationId,
    };

    let myInit = {
      body: body, // replace this with attributes you need
    }

    const { enqueueSnackbar } = this.props;

    API.post(apiName, path, myInit).then(response => {
      console.log(response)

      let confirmCancelReservationId = this.state.confirmCancelReservationId;


      let activeReservations = this.state.activeReservations.filter(function(item, index){
        if (item.reservation_id !== confirmCancelReservationId) return true;
        return false;
      });

      let canceledTodoReservations = this.state.canceledTodoReservations;

      let cancelReservationItem = this.state.activeReservations.find((item) => {
        if(item.reservation_id === confirmCancelReservationId){return true}
        return false
      })

      if(cancelReservationItem.is_jalan === 'no'){
        canceledTodoReservations.unshift(cancelReservationItem);
      }

      this.setState({
        cancelOpen: false,
        confirmCancelReservationId: "",
        activeReservations: activeReservations,
        canceledTodoReservations: canceledTodoReservations,
      });

      enqueueSnackbar(response.message, {variant : 'success'});

    }).catch(error => {
      console.log(error)
      if(error.message){
        enqueueSnackbar(error.message, {variant : 'error'})
      }else{
        enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
      }
    });
  }

  afterPrint  = () => {
    this.setState({
      printOpen: false,
      printReservaionSheetOpen: false
    });
  }

  //じゃらん再開済用関数

  handleClickOpen = (reservationId, today) => {
    this.setState({
      canceledCompleteOpen: true,
      confirmCanceledCompleteReservationId: reservationId,
    },() => {
      console.log("state: ", this.state)
    });
  };


  canceledComplete = () => {
    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/canceled-complete'; //replace this with the path you have configured on your API

    let body = {
      reservationId : this.state.confirmCanceledCompleteReservationId,
    };

    let myInit = {
      body: body, // replace this with attributes you need
    }

    const { enqueueSnackbar } = this.props;

    API.post(apiName, path, myInit).then(response => {
      console.log(response)

      let confirmCanceledCompleteReservationId = this.state.confirmCanceledCompleteReservationId;

      let canceledTodoReservationsAfter = this.state.canceledTodoReservations.filter(function(item, index){
        if (item.reservation_id !== confirmCanceledCompleteReservationId) return true;
        return false;
      });

      this.setState({
        canceledCompleteOpen: false,
        confirmCanceledCompleteReservationId: "",
        canceledTodoReservations: canceledTodoReservationsAfter
      });

      enqueueSnackbar(response.message, {variant : 'success'});

    }).catch(error => {
      console.log(error)
      if(error.message){
        enqueueSnackbar(error.message, {variant : 'error'})
      }else{
        enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
      }
    });
  }

  handleleOnFocus = (value, key) => {
    this.setState({
      [key + "OnFocus"] : value
    })
  }

  render() {
    const {classes, theme} = this.props
    const {
      activeReservations,
      canceledTodoReservations,
      date,
      dateNum,
      inputRooms,
      rooms,
      roomError,
      inputBasePlan,
      inputBedPlan,
      inputMealPlan,
      inputUnitPrice,
      inputAmount,
      plans,
      planError,
      isJalan,
      jalanPaid,
      extraCharge,
      discount,
      gotoDiscount,
      jalanNumber,
      jalanPoint,
      jalanCoupon,
      jalanSubsidy,
      taxRate,
      planShortageError,
      planNegativeError,
      babyChairs,
      joinBed,
      plasticBag,
      familyMemberOpen,
      scroll,
      babyM,
      babyW,
      kindergartenM,
      kindergartenW,
      elementarySchoolLowM,
      elementarySchoolLowW,
      elementarySchoolMiddleM,
      elementarySchoolMiddleW,
      elementarySchoolHighM,
      elementarySchoolHighW,
      juniorHighSchoolM,
      juniorHighSchoolW,
      highSchoolM,
      highSchoolW,
      universityM,
      universityW,
      twentiesM,
      twentiesW,
      thirtiesM,
      thirtiesW,
      fortiesM,
      fortiesW,
      fiftiesM,
      fiftiesW,
      sixtiesM,
      sixtiesW,
      overSeventiesM,
      overSeventiesW,
      transportation,
      planNote,
      isRepeatCustomer,
      repeatCustomerId,
      searchCustomersResult,
      repeatCustomerOpen,
      lastNameKanaSC,
      firstNameKanaSC,
      telSC,
      emailSC,
      lastName,
      lastNameOnFocus,
      lastNameList,
      firstName,
      lastNameKana,
      lastNameKanaOnFocus,
      firstNameKana,
      tel,
      tel2,
      email,
      postNum,
      addressPrefectures,
      addressCity,
      addressOther,
      addressBuilding,
      customerNote,
      canceledCompleteOpen,
      targetReservationId
    } = this.state;

    return (
      <Fragment>
        <Grid container spacing={24} className={classes.container}>
          <Grid item xs={12}>
            <Typography variant="h4" gutterBottom>
              予約管理
            </Typography>
          </Grid>
          <Grid item>

            <Typography variant="h6" gutterBottom　style={{display: activeReservations.length === 0 && canceledTodoReservations.length === 0 ? "" : "none"}}>
              表示する予約がありません
            </Typography>

            <Paper className={classes.root} elevation={1} style={{display: activeReservations.length > 0 ? "" : "none"}}>
              <Typography variant="h5" gutterBottom>
                アクティブな予約
              </Typography>
              <Table className={classes.table} style={{marginTop: 20}}>
                <TableHead style={{backgroundColor:"#f3f3f3"}}>
                  <TableRow>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">宿泊開始日</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">お部屋</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">お名前</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">じゃらん停止</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">ご案内/メール送付</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {activeReservations.map(n =>
                    {
                      let s1 = n.reservation_id + "S1";
                      let c2 = n.reservation_id + "C2";
                      let s2 = n.reservation_id + "S2";
                      let rooms = "";
                      for(let i in n.input_rooms){
                        rooms = rooms + n.input_rooms[i]
                        if(i !== n.input_rooms.length - 1){
                          rooms = rooms + " "
                        }
                      }
                      let bg = "#d2d2d2";
                      if(this.state[s1] === "no" || (this.state[c2] === "no" && this.state[s2] === "no")){
                        bg = "";
                      }
                      if(targetReservationId === n.reservation_id){
                        bg = "#60ffff"
                      }
                      return (
                        <TableRow key={n.reservation_id} style={{backgroundColor: bg}}>
                          <TableCell align="center" padding="dense">{n.date}</TableCell>
                          <TableCell align="center" padding="dense">{rooms}</TableCell>
                          <TableCell align="center" padding="dense">{n.last_name} {n.first_name}<div style={{marginLeft: 10, fontSize:"0.8em", display: "inline"}}>様</div></TableCell>
                          <TableCell align="center" padding="dense">
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={this.state[s1] === "yes" ? true : false}
                                  onChange={(e) => this.handleChangeSwitch(e, s1)}
                                  value={s1}
                                  color="primary"
                                />
                              }
                              label={this.state[s1] === "yes" ? "完了" : "未　"}
                            />
                          </TableCell>
                          <TableCell align="center" padding="dense">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={this.state[c2] === "yes" ? true : false}
                                  disabled={this.state[s2] === "yes" ? true : false}
                                  onChange={(e) => this.handleChangeSwitch(e, c2)}
                                  value={c2}
                                  color="primary"
                                />
                              }
                              label="不要"
                            />
                            <br/>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={this.state[s2] === "yes" ? true : false}
                                  disabled={this.state[c2] === "yes" ? true : false}
                                  onChange={(e) => this.handleChangeSwitch(e, s2)}
                                  value={s2}
                                  color="primary"
                                />
                              }
                              label={this.state[s2] === "yes" ? "完了" : "未　"}
                            />

                          </TableCell>
                          <TableCell style={{color: "#676767"}} align="center" padding="dense">

                            <Button
                              type="submit"
                              variant="contained"
                              color="default"
                              className={classes.button}
                              onClick={() => this.handleReservationOpen(n.reservation_id)}
                              style={{marginBottom:15,marginTop:5}}
                            >
                              <ListItemIcon><SvgIcon size={18} icon={phone}/></ListItemIcon>
                              予約情報変更
                            </Button>
                            <br/>
                            <Button
                              type="submit"
                              variant="contained"
                              color="default"
                              className={classes.button}
                              onClick={() => this.handleCustomerOpen(n.customer_id, n.reservation_id)}
                              style={{marginBottom:15}}
                            >
                              <ListItemIcon><SvgIcon size={18} icon={user}/></ListItemIcon>
                              顧客情報変更
                            </Button>

                            <br/>
                            <Button
                              variant="contained"
                              color="default"
                              className={classes.button}
                              onClick={() => this.handlePrintOpen(n.reservation_id, n.customer_id)}
                              style={{marginBottom:15}}
                            >
                              <ListItemIcon><SvgIcon size={18} icon={envelopeOpen}/></ListItemIcon>
                              ご案内印刷　
                            </Button>
                            <br/>
                            <Button
                              variant="contained"
                              color="default"
                              className={classes.button}
                              onClick={() => this.handlePrintReservationSheetOpen(n.reservation_id, n.customer_id)}
                              style={{marginBottom:15}}
                            >
                              <ListItemIcon><SvgIcon size={18} icon={file}/></ListItemIcon>
                              予約表印刷　
                            </Button>

                            <br/>
                            <Button
                              type="submit"
                              variant="contained"
                              color="default"
                              className={classes.button}
                              onClick={() => this.handleCancelOpen(n.reservation_id)}
                              style={{marginBottom:5}}
                            >
                              <ListItemIcon><SvgIcon size={18} icon={remove}/></ListItemIcon>
                              キャンセル　
                            </Button>
                            <div ref={(ref) => this["ref" + n.reservation_id] = ref}></div>
                          </TableCell>
                        </TableRow>
                      );
                    }
                  )}
                </TableBody>
              </Table>

            </Paper>

            <Paper className={classes.root} elevation={1} style={{marginTop: 30, display: canceledTodoReservations.length > 0 ? "" : "none"}}>
              <Typography variant="h5" gutterBottom>
                キャンセル済み予約（じゃらん再開前）
              </Typography>
              <Table className={classes.table} style={{marginTop: 20}}>
              <TableHead style={{backgroundColor:"#f3f3f3"}}>
                <TableRow>
                  <TableCell style={{color: "#676767"}} align="center" padding="dense">宿泊開始日</TableCell>
                  <TableCell style={{color: "#676767"}} align="center" padding="dense">お部屋</TableCell>
                  <TableCell style={{color: "#676767"}} align="center" padding="dense">お名前</TableCell>
                  <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                </TableRow>
              </TableHead>
                <TableBody>
                  {canceledTodoReservations.map(n =>
                    {
                      let rooms = "";
                      for(let i in n.input_rooms){
                        rooms = rooms + n.input_rooms[i]
                        if(i !== n.input_rooms.length - 1){
                          rooms = rooms + " "
                        }
                      }
                      return (
                        <TableRow key={n.reservation_id}>
                          <TableCell align="center" padding="dense">{n.date}</TableCell>
                          <TableCell align="center" padding="dense">{rooms}</TableCell>
                          <TableCell align="center" padding="dense">{n.last_name} {n.first_name} <div style={{marginLeft: 10, fontSize:"0.8em", display: "inline"}}>様</div></TableCell>
                          <TableCell align="center" padding="dense">
                            <Button type="submit" variant="contained" color="default" className={classes.button} onClick={() => this.handleClickOpen(n.reservation_id)}>
                              じゃらん再開済
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    }
                  )}
                </TableBody>
              </Table>
            </Paper>


          </Grid>
        </Grid>

        <Letter ref={el => (this.componentRef = el)} state={this.state}/>
        <ReservationSheet ref={el => (this.componentRefReservationSheel = el)} state={this.state}/>

        <Dialog
          open={this.state.reservationOpen}
          onClose={() => this.handleClose('reservationOpen')}
          scroll={scroll}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          fullWidth={true}
          maxWidth="md"
        >
          <DialogTitle id="scroll-dialog-title">予約情報変更</DialogTitle>
          <DialogContent>
            <ValidatorForm
              ref="form"
              onSubmit={(e) => this.updateReservatiion(e)}
              onError={
                errors => {
                  console.log(errors);
                  const { enqueueSnackbar } = this.props;
                  enqueueSnackbar('入力エラーがあります。確認してください。', {variant : 'warning'});
                }
              }
            >
              <TextValidator
                className={classes.textField}
                name="date"
                label="宿泊開始日"
                value={date}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'date')}
                type="date"
                required={true}
                validators={['required', 'matchRegexp:^\\d{4}-\\d{1,2}-\\d{1,2}$']}
                errorMessages={['必須項目を入力してください', '日付が間違っています']}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextValidator
                className={classes.textField}
                name="dateNum"
                label="宿泊日数"
                value={dateNum}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'dateNum')}
                type="number"
                required={true}
                validators={['required', 'isNumber', 'minNumber:1']}
                errorMessages={['必須項目を入力してください', '整数を入力してください', '1以上の数を入力してください']}
              />
              <br/>
              <FormControl required={true} error={roomError} className={classes.formControl} style={{minWidth: 120, maxWidth: 300}}>
                <InputLabel htmlFor="select-multiple-chip">お部屋</InputLabel>
                <Select
                  multiple
                  autoWidth={true}
                  value={inputRooms}
                  onChange={(e) => this.handleChange(e, 'inputRooms')}
                  input={<Input id="select-multiple-chip" />}
                  renderValue={selected => (
                    <div className={classes.chips}>
                      {selected.map(value => (
                        <Chip key={value} label={value} className={classes.chip} />
                      ))}
                    </div>
                  )}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 488,
                        width: 250,
                      },
                    },
                  }}
                >
                  {roomNames.map(room => (
                    <MenuItem
                      key={room}
                      value={room}
                      name="room"
                      style={{
                        fontWeight:
                          room.indexOf(room) === -1
                            ? theme.typography.fontWeightRegular
                            : theme.typography.fontWeightMedium,
                      }}
                    >
                      {room}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{roomError ? "お部屋を指定してください" : ""}</FormHelperText>
              </FormControl>
              <Chip
                label={(() => {
                  let capacity = 0
                  if(rooms.length !== 0){
                    rooms.forEach(room => (capacity += room.capacity))
                  }
                  return "お部屋の定員の合計:　　　" + capacity

                })()}
                className={classes.chip}
                style={{marginLeft:30, marginBottom:26, verticalAlign:"bottom", width:200, backgroundColor:"#efefef"}}
              />
              <br/>
            <Paper className={classes.root}>
              <Typography variant="subtitle1" gutterBottom>
                プラン*
              </Typography>
              <div style={{display: planError}}>
                <Typography color="error" style={{display: "inline-flex", verticalAlign:"middle", marginTop:10}}>
                  <ErrorIcon style={{marginTop: -3}} />プランを入力してください
                </Typography>
                <br/>
              </div>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={(e) => this.handleChangeCheck(e,'isJalan')}
                    value={isJalan}
                    checked={isJalan === "yes" ? true : false }
                    color="primary"
                  />
                }
                label="じゃらん予約"
                style={{marginTop:10}}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={(e) => this.handleChangeCheck(e,'jalanPaid')}
                    value={jalanPaid}
                    checked={jalanPaid === "yes" ? true : false }
                    color="primary"
                  />
                }
                label="じゃらん支払済"
                style={{marginTop:10, display:isJalan === "yes" ? "" : "none"}}
              />
              <br/>
              <FormControl className={classes.formControl} style={{marginBottom:30, width:150}}>
                <InputLabel htmlFor="customer-type-helper">ベースプラン</InputLabel>
                <Select
                  value={inputBasePlan}
                  onChange={(e) => this.handleChange(e,'inputBasePlan')}
                  input={<Input name="type" id="customer-type-helper" />}
                  style={{paddingTop:8}}
                >
                  <MenuItem value=""><em>None</em></MenuItem>
                  <MenuItem value={'大人'}>大人</MenuItem>
                  <MenuItem value={'ジュニア'}>ジュニア</MenuItem>
                  <MenuItem value={'キッズ'}>キッズ</MenuItem>
                  <MenuItem value={'素泊り'}>素泊り</MenuItem>
                </Select>
              </FormControl>
              <FormControl className={classes.formControl} style={{marginBottom:30, width:100}}>
                <InputLabel htmlFor="customer-type-helper">ベッド</InputLabel>
                <Select
                  value={inputBedPlan}
                  onChange={(e) => this.handleChange(e,'inputBedPlan')}
                  input={<Input name="type" id="customer-type-helper" />}
                  style={{paddingTop:8}}
                >
                  <MenuItem value=""><em>None</em></MenuItem>
                  <MenuItem value={'有'}>有</MenuItem>
                  <MenuItem value={'無'}>無</MenuItem>
                </Select>
              </FormControl>
              <FormControl
                disabled={inputBasePlan === "素泊り" ? true : false}
                className={classes.formControl}
                style={{marginBottom:30, width:120}}
              >
                <InputLabel htmlFor="customer-type-helper">{inputBasePlan === "素泊り" ? "食事なし" : "食事"}</InputLabel>
                <Select
                  value={inputMealPlan}
                  onChange={(e) => this.handleChange(e,'inputMealPlan')}
                  input={<Input name="type" id="customer-type-helper" />}
                  style={{paddingTop:8}}
                >
                  <MenuItem value=""><em>None</em></MenuItem>
                  <MenuItem value={'2食付'}>2食付</MenuItem>
                  <MenuItem value={'朝食付'}>朝食付</MenuItem>
                  <MenuItem value={'夕食付'}>夕食付</MenuItem>
                </Select>
              </FormControl>
              <TextValidator
                className={classes.textField}
                name="inputUnitPrice"
                label="単価"
                value={inputUnitPrice}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'inputUnitPrice')}
                type="number"
                validators={['isNumber', 'minNumber:1']}
                errorMessages={['整数を入力してください', '1以上の数を入力してください']}
                style={{width:170}}
              />
              <TextValidator
                className={classes.textField}
                name="inputAmount"
                label="人数"
                value={inputAmount}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'inputAmount')}
                type="number"
                validators={['isNumber', 'minNumber:1']}
                errorMessages={['整数を入力してください', '1以上の数を入力してください']}
                style={{width:80}}
              />
              <Button onClick={this.handleAddPlan} variant="contained" color="default" className={classes.button} style={{marginLeft:10, marginTop:25}}>
                追加
              </Button>
              <br/>
              <TextValidator
                className={classes.textField}
                name="extraCharge"
                label="追加チャージ"
                value={extraCharge}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'extraCharge')}
                type="number"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width:170, display:isJalan === "no" ? "" : "none"}}
              />
              <TextValidator
                className={classes.textField}
                name="discount"
                label="割引"
                value={discount}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'discount')}
                type="number"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width:170, display:isJalan === "no" ? "" : "none"}}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={(e) => this.handleChangeCheck(e,'gotoDiscount')}
                    value={gotoDiscount}
                    checked={gotoDiscount === "yes" ? true : false }
                    color="primary"
                  />
                }
                label="GoToキャンペーン35%割引"
                style={{marginLeft:10, marginTop:20, display:isJalan === "no" ? "" : "none"}}
              />
              <TextValidator
                className={classes.textField}
                name="jalanNumber"
                label="じゃらん No."
                value={jalanNumber}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'jalanNumber')}
                type="number"
                required={isJalan === "yes" ? true : false}
                validators={['isNumber']}
                errorMessages={['整数を入力してください']}
                style={{width: 130, display:isJalan === "yes" ? "" : "none"}}
              />
              <br/>
              <TextValidator
                className={classes.textField}
                name="jalanPoint"
                label="ポイント利用額"
                value={jalanPoint}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'jalanPoint')}
                type="number"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 130, display:isJalan === "yes" ? "" : "none"}}
              />
              <TextValidator
                className={classes.textField}
                name="jalanCoupon"
                label="クーポン利用額"
                value={jalanCoupon}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'jalanCoupon')}
                type="number"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 130, display:isJalan === "yes" ? "" : "none"}}
              />
              <TextValidator
                className={classes.textField}
                name="jalanSubsidy"
                label="補助金利用額"
                value={jalanSubsidy}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'jalanSubsidy')}
                type="number"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 130, display:isJalan === "yes" ? "" : "none"}}
              />
              <br/>
              <div style={{display: planShortageError, textAlign:'right'}}>
                <Typography color="error" style={{display: "inline-flex", verticalAlign:"middle", marginBottom:10}}>
                  <ErrorIcon style={{marginTop: -3}} />すべての項目を入力してください
                </Typography>
                <br/>
              </div>
              <br/>
              <div style={{display: planNegativeError, textAlign:'right'}}>
                <Typography color="error" style={{display: "inline-flex", verticalAlign:"middle", marginBottom:10}}>
                  <ErrorIcon style={{marginTop: -3}} />金額がプラスになるように入力してください
                </Typography>
                <br/>
              </div>
                <Table className={classes.table}>
                  <TableHead style={{backgroundColor:"#f3f3f3"}}>
                    <TableRow>
                      <TableCell style={{color: "#676767"}}>ベースプラン</TableCell>
                      <TableCell style={{color: "#676767"}}>ベッド</TableCell>
                      <TableCell style={{color: "#676767"}}>食事</TableCell>
                      <TableCell style={{color: "#676767"}} align="right">単価</TableCell>
                      <TableCell style={{color: "#676767"}} align="right">人数</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {plans.map(n =>
                      {
                        return (
                          <TableRow key={n.id}>
                            <TableCell>{n.basePlan}</TableCell>
                            <TableCell>{n.bedPlan}</TableCell>
                            <TableCell>{n.mealPlan}</TableCell>
                            <TableCell align="right">￥{Number(n.unitPrice).toLocaleString()}</TableCell>
                            <TableCell align="right">{n.amount}名</TableCell>
                            <TableCell>
                              <IconButton className={classes.button} aria-label="Delete" onClick={() => this.handleDeletePlan(n.id)}>
                                <DeleteIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      }
                    )}
                    <TableRow key="space">
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                    <TableRow key="totalAmount" style={{backgroundColor:"#f3f3f3"}}>
                      <TableCell>人数合計</TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell align="right">{this.getTotalAmount()}名</TableCell>
                    </TableRow>
                    <TableRow key="totalPrice" style={{backgroundColor:"#d0d0d0"}}>
                      <TableCell>宿泊料金小計</TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell align="right">￥{Number(this.getTotalPrice()).toLocaleString()}</TableCell>
                    </TableRow>
                    <TableRow key="extraCharge" style={{backgroundColor:"#f3f3f3", display:isJalan === "no" ? "" : "none"}}>
                      <TableCell>追加チャージ</TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell align="right">￥{Number(extraCharge).toLocaleString()}</TableCell>
                    </TableRow>
                    <TableRow key="discount" style={{backgroundColor:"#f3f3f3", display:isJalan === "no" ? "" : "none"}}>
                      <TableCell>割引</TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell align="right">- ￥{Number(discount).toLocaleString()}</TableCell>
                    </TableRow>

                    {/* GoToキャンペーンの計算 */}
                    <TableRow key="totalPriceWithTax" style={{backgroundColor:"#d0d0d0", display:gotoDiscount === "yes" ? "" : "none"}}>
                      <TableCell>宿泊料金小計(税込)</TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell align="right">￥{Math.ceil(Math.floor(((Number(this.getTotalPrice()) + Number(extraCharge) - Number(discount)) * (1 + Number(taxRate))))).toLocaleString()}</TableCell>
                    </TableRow>
                    <TableRow key="goto" style={{backgroundColor:"#f3f3f3", display:gotoDiscount === "yes" ? "" : "none"}}>
                      <TableCell>GoToキャンペーン割引(35%)</TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell align="right">- ￥{Math.ceil(Math.floor(((Number(this.getTotalPrice()) + Number(extraCharge) - Number(discount)) * (1 + Number(taxRate)))) * 0.35).toLocaleString()}</TableCell>
                    </TableRow>

                    <TableRow key="totalPriceAddAll" style={{backgroundColor:"#d0d0d0", display:isJalan === "no" ? gotoDiscount === "yes" ? "none" : "" : "none"}}>
                      <TableCell>宿泊料金合計</TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell align="right">￥{(Number(this.getTotalPrice()) + Number(extraCharge) - Number(discount)).toLocaleString()}</TableCell>
                    </TableRow>

                    <TableRow key="tax" style={{backgroundColor:"#f3f3f3", display:isJalan === "no" ? gotoDiscount === "yes" ? "none" : "" : "none"}}>
                      <TableCell>消費税({taxRate * 100}%)</TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell align="right">￥{Math.floor(((Number(this.getTotalPrice()) + Number(extraCharge) - Number(discount)) * taxRate)).toLocaleString()}</TableCell>
                    </TableRow>

                    <TableRow key="totalPriceGoto" style={{backgroundColor:"#d0d0d0", display:isJalan === "no" ? gotoDiscount === "yes" ? "" : "none" : "none"}}>
                      <TableCell>ご請求金額(税込)</TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell align="right">￥{(Math.floor(((Number(this.getTotalPrice()) + Number(extraCharge) - Number(discount)) * (1 + Number(taxRate)))) - Math.ceil(Math.floor(((Number(this.getTotalPrice()) + Number(extraCharge) - Number(discount)) * (1 + Number(taxRate)))) * 0.35)).toLocaleString()}</TableCell>
                    </TableRow>

                    <TableRow key="totalPricePlusTax" style={{backgroundColor:"#d0d0d0", display:isJalan === "no" ? gotoDiscount === "yes" ? "none" : "" : "none"}}>
                      <TableCell>ご請求金額(税込)</TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell align="right">￥{Math.floor(((Number(this.getTotalPrice()) + Number(extraCharge) - Number(discount)) * (1 + Number(taxRate)))).toLocaleString()}</TableCell>
                    </TableRow>
                    {/* GoToキャンペーンの計算 */}

                    <TableRow key="jalanDiscount" style={{backgroundColor:"#f3f3f3", display:isJalan === "yes" ? "" : "none"}}>
                      <TableCell>じゃらん割引額</TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell align="right">- ￥{(Number(jalanPoint) + Number(jalanCoupon) + Number(jalanSubsidy)).toLocaleString()}</TableCell>
                    </TableRow>
                    <TableRow key="totalPriceAddDiscount" style={{backgroundColor:"#d0d0d0", display:isJalan === "yes" ? "" : "none"}}>
                      <TableCell>ご請求金額(税込)</TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell align="right">￥{(Number(this.getTotalPrice()) - (Number(jalanPoint) + Number(jalanCoupon) + Number(jalanSubsidy))).toLocaleString()}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
                <Typography style={{margin:20, color:"#8c8c8c"}}>
                  ■追加チャージ<br/>
                  ※ツインルーム: シングルチャージは +1800円 (税別料金に追加)<br/>
                  ※トリプル・カルテット・レビュラー: 減1ベッド時はベッド使用者が +1000円 (税別料金に追加)
                </Typography>
                <div style={
                  {
                    display:
                    (Number(this.getTotalPrice()) - (Number(jalanPoint) + Number(jalanCoupon) + Number(jalanSubsidy))) < 0 ||
                    (Number(this.getTotalPrice()) + Number(extraCharge) - Number(discount)) < 0
                    ? ""
                    : "none"
                    ,
                    textAlign:'right',
                    marginTop: 15
                  }
                }>
                  <Typography color="error" style={{display: "inline-flex", verticalAlign:"middle"}}>
                    <ErrorIcon style={{marginTop: -3}} />合計金額がマイナスになっています
                  </Typography>
                  <br/>
                </div>
              </Paper>
              <br/>
              <TextValidator
                className={classes.textField}
                name="joinBed"
                label="くっつけるベッド数"
                value={joinBed}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'joinBed')}
                type="number"
                min="0"
                required={true}
                validators={['required', 'isNumber', 'minNumber:0']}
                errorMessages={['必須項目を入力してください', '整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <TextValidator
                className={classes.textField}
                name="babyChairs"
                label="幼児用椅子の数"
                value={babyChairs}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'babyChairs')}
                type="number"
                min="0"
                required={true}
                validators={['required', 'isNumber', 'minNumber:0']}
                errorMessages={['必須項目を入力してください', '整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <FormControlLabel className={classes.PlasticBagCheckboxFormControl}
                control={
                  <Checkbox
                    onChange={(e) => this.handleChangeCheck(e,'plasticBag')}
                    value={plasticBag}
                    checked={plasticBag === "yes" ? true : false }
                    color="primary"
                  />
                }
                label="ビニール袋必要"
              />
              <br/>
              <br/>
              <Button variant="contained" color="default" onClick={() => this.handleClickOpenDialog('paper', 'familyMemberOpen')} style={{marginLeft:5, marginTop:18}}>顧客構成</Button>
              <Dialog
                open={familyMemberOpen}
                onClose={() => this.handleCloseDialog('familyMemberOpen')}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
              >
                <DialogTitle id="scroll-dialog-title">顧客構成</DialogTitle>
                <DialogContent>
                  <Typography variant="subtitle1" style={{display:'inline', marginRight: 135}}>
                    男性
                  </Typography>
                  <Typography variant="subtitle1" style={{display:'inline'}}>
                    女性
                  </Typography>
                  <br/>
                  <TextValidator
                    className={classes.textField}
                    name="babyM"
                    label="〜3歳"
                    value={babyM}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'babyM')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <TextValidator
                    className={classes.textField}
                    name="babyW"
                    label="〜3歳"
                    value={babyW}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'babyW')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <br/>
                  <TextValidator
                    className={classes.textField}
                    name="kindergartenM"
                    label="幼稚園児"
                    value={kindergartenM}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'kindergartenM')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <TextValidator
                    className={classes.textField}
                    name="kindergartenW"
                    label="幼稚園児"
                    value={kindergartenW}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'kindergartenW')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <br/>
                  <TextValidator
                    className={classes.textField}
                    name="elementarySchoolLowM"
                    label="小学校低学年"
                    value={elementarySchoolLowM}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'elementarySchoolLowM')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <TextValidator
                    className={classes.textField}
                    name="elementarySchoolLowW"
                    label="小学校低学年"
                    value={elementarySchoolLowW}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'elementarySchoolLowW')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <br/>
                  <TextValidator
                    className={classes.textField}
                    name="elementarySchoolMiddleM"
                    label="小学校中学年"
                    value={elementarySchoolMiddleM}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'elementarySchoolMiddleM')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <TextValidator
                    className={classes.textField}
                    name="elementarySchoolMiddleW"
                    label="小学校中学年"
                    value={elementarySchoolMiddleW}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'elementarySchoolMiddleW')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <br/>
                  <TextValidator
                    className={classes.textField}
                    name="elementarySchoolHighM"
                    label="小学校高学年"
                    value={elementarySchoolHighM}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'elementarySchoolHighM')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <TextValidator
                    className={classes.textField}
                    name="elementarySchoolHighW"
                    label="小学校高学年"
                    value={elementarySchoolHighW}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'elementarySchoolHighW')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <br/>
                  <TextValidator
                    className={classes.textField}
                    name="juniorHighSchoolM"
                    label="中学生"
                    value={juniorHighSchoolM}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'juniorHighSchoolM')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <TextValidator
                    className={classes.textField}
                    name="juniorHighSchoolW"
                    label="中学生"
                    value={juniorHighSchoolW}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'juniorHighSchoolW')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <br/>
                  <TextValidator
                    className={classes.textField}
                    name="highSchoolM"
                    label="高校生"
                    value={highSchoolM}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'highSchoolM')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <TextValidator
                    className={classes.textField}
                    name="highSchoolW"
                    label="高校生"
                    value={highSchoolW}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'highSchoolW')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <br/>
                  <TextValidator
                    className={classes.textField}
                    name="universityM"
                    label="大学生(19歳-22歳)"
                    value={universityM}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'universityM')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <TextValidator
                    className={classes.textField}
                    name="universityW"
                    label="大学生(19歳-22歳)"
                    value={universityW}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'universityW')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <br/>
                  <TextValidator
                    className={classes.textField}
                    name="twentiesM"
                    label="20代"
                    value={twentiesM}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'twentiesM')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <TextValidator
                    className={classes.textField}
                    name="twentiesW"
                    label="20代"
                    value={twentiesW}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'twentiesW')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <br/>
                  <TextValidator
                    className={classes.textField}
                    name="thirtiesM"
                    label="30代"
                    value={thirtiesM}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'thirtiesM')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <TextValidator
                    className={classes.textField}
                    name="thirtiesW"
                    label="30代"
                    value={thirtiesW}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'thirtiesW')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <br/>
                  <TextValidator
                    className={classes.textField}
                    name="fortiesM"
                    label="40代"
                    value={fortiesM}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'fortiesM')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <TextValidator
                    className={classes.textField}
                    name="fortiesW"
                    label="40代"
                    value={fortiesW}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'fortiesW')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <br/>
                  <TextValidator
                    className={classes.textField}
                    name="fiftiesM"
                    label="50代"
                    value={fiftiesM}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'fiftiesM')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <TextValidator
                    className={classes.textField}
                    name="fiftiesW"
                    label="50代"
                    value={fiftiesW}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'fiftiesW')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <br/>
                  <TextValidator
                    className={classes.textField}
                    name="sixtiesM"
                    label="60代"
                    value={sixtiesM}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'sixtiesM')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <TextValidator
                    className={classes.textField}
                    name="sixtiesW"
                    label="60代"
                    value={sixtiesW}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'sixtiesW')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <br/>
                  <TextValidator
                    className={classes.textField}
                    name="overSeventiesM"
                    label="70代以上"
                    value={overSeventiesM}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'overSeventiesM')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                  <TextValidator
                    className={classes.textField}
                    name="overSeventiesW"
                    label="70代以上"
                    value={overSeventiesW}
                    margin="normal"
                    onChange={(e) => this.handleChange(e, 'overSeventiesW')}
                    type="number"
                    min="0"
                    validators={['isNumber', 'minNumber:0']}
                    errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                    style={{width: 150}}
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => this.handleCloseDialog('familyMemberOpen')} color="primary">
                    閉じる
                  </Button>
                </DialogActions>
              </Dialog>
              <FormControl className={classes.formControl} style={{width:150, marginLeft:50}}>
                <InputLabel htmlFor="customer-type-helper">交通手段</InputLabel>
                <Select
                  value={transportation}
                  onChange={(e) => this.handleChange(e,'transportation')}
                  input={<Input name="type" id="customer-type-helper" />}
                >
                  <MenuItem value=""><em>None</em></MenuItem>
                  <MenuItem value={'車'}>車</MenuItem>
                  <MenuItem value={'バス'}>バス</MenuItem>
                  <MenuItem value={'未定'}>未定</MenuItem>
                </Select>
              </FormControl>
              <br/>
              <TextValidator
                className={classes.textField}
                name="planNote"
                label="備考"
                value={planNote}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'planNote')}
                required={false}
                multiline={true}
                rows={3}
                style={{width:600}}
              />
              <br/>
              <Button type="submit" variant="contained" color="primary" className={classes.button} style={{marginLeft: "90%", marginTop:40}}>
                更新
              </Button>
            </ValidatorForm>
          </DialogContent>
        </Dialog>



        <Dialog
          open={this.state.customerOpen}
          onClose={() => this.handleClose('customerOpen')}
          scroll={scroll}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          fullWidth={true}
          maxWidth="md"
        >
          <DialogTitle id="scroll-dialog-title">顧客情報変更</DialogTitle>
          <DialogContent>
            <ValidatorForm
              ref="form"
              onSubmit={(e) => this.updateCustomer(e)}
              onError={
                errors => {
                  console.log(errors);
                  const { enqueueSnackbar } = this.props;
                  enqueueSnackbar('入力エラーがあります。確認してください。', {variant : 'warning'});
                }
              }
            >
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={(e) => this.handleChangeCheck(e,'isRepeatCustomer')}
                    value={isRepeatCustomer}
                    checked={isRepeatCustomer === "yes" ? true : false }
                    color="primary"
                  />
                }
                label="リピーター"
                style={{marginTop:10, marginBottom:10}}
              />
              <Button
                variant="contained"
                color="default"
                onClick={() => this.handleClickOpenDialog('paper', 'repeatCustomerOpen')}
                style={{marginLeft:10, display:isRepeatCustomer === "yes" ? "" : "none"}}
              >
                顧客検索
              </Button>
              <br/>
              {isRepeatCustomer === "yes" && repeatCustomerId &&
                <Fragment>
                  <Typography color="primary" style={{display: "inline-flex", verticalAlign:"middle", marginBottom:10}}>
                    <CheckCircleIcon style={{marginTop: -3}} />リピーター情報設定済み
                  </Typography>
                  <Typography variant= "body2" style={{marginBottom:20, marginLeft:10, color:"#585858"}}>
                    ※リピーターの情報を更新する場合は、更新箇所だけ変更してください。
                  </Typography>
                </Fragment>
              }
              {isRepeatCustomer === "yes" && repeatCustomerId === "" &&
                <Typography color="error" style={{display: "inline-flex", verticalAlign:"middle", marginBottom:20}}>
                  <ErrorIcon style={{marginTop: -3}} />リピーター情報を設定してください
                </Typography>
              }
              <Typography variant="h6" gutterBottom>
                お名前
              </Typography>
              <TextValidator
                className={classes.textField}
                name="lastNameKana"
                label="氏(カナ)"
                value={lastNameKana}
                margin="normal"
                onChange={(e) => this.doSearch(e, 'lastNameKana')}
                onFocus ={() => this.handleleOnFocus("yes", "lastNameKana")}
                onBlur  ={() => this.handleleOnFocus("no", "lastNameKana")}
                pattern="^[ァ-ンヴー]+$ , [\\u30A1-\\u30FF]*"
                required={true}
                validators={['required', 'matchRegexp:^[ァ-ンヴー]+$']}
                errorMessages={['必須項目を入力してください', 'カタカナで入力してください']}
                helperText="カタカナ入力"
              />
              <Paper
                square
                style={{
                  position: "absolute",
                  zIndex : 1,
                  width: "600px",
                  maxHeight: "300px",
                  marginTop: "-20px",
                  marginLeft : "8px",
                  overflow : "scroll",
                  display: lastNameKanaOnFocus === "yes" && searchCustomersResult.length > 0 ? "" : "none",
                }}
              >
                <div
                  style={{
                    color: "#0000008a",
                    margin: "10px"
                  }}
                >
                  リピーター候補
                </div>
                {searchCustomersResult.map(n => (
                  <MenuItem
                    key={n.customer_id}
                    onMouseDown={() => this.setRepeatCustomer(n.customer_id)}
                  >
                    {n.last_name} {n.first_name}
                    <span
                      style={{
                        fontSize: "0.7em",
                        marginLeft: "18px",
                        marginTop: "3px",
                        color: "#0000008a",
                        varticalAlign: "bottom"
                      }}
                    >
                      住所:
                    </span>
                    <span
                      style={{
                        fontSize: "0.8em",
                        marginLeft: "2px",
                        marginTop: "2px",
                        varticalAlign: "middle"
                      }}
                    >
                      {n.address_prefectures} {n.address_city}
                    </span>
                    <span
                      style={{
                        fontSize: "0.7em",
                        marginLeft: "18px",
                        marginTop: "3px",
                        color: "#0000008a",
                        varticalAlign: "bottom"
                      }}
                    >
                      前回宿泊日:
                    </span>
                    <span
                      style={{
                        fontSize: "0.8em",
                        marginLeft: "2px",
                        marginTop: "2px",
                        varticalAlign: "middle"
                      }}
                    >
                      {moment(n.reservation_date_history[0]).format("YYYY年MM月DD日(ddd)")}
                    </span>
                  </MenuItem>
                ))}
              </Paper>
              <TextValidator
                className={classes.textField}
                name="firstNameKana"
                label="名（カナ）"
                value={firstNameKana}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'firstNameKana')}
                pattern="^[ァ-ンヴー]+$ , [\\u30A1-\\u30FF]*"
                required={true}
                validators={['required', 'matchRegexp:^[ァ-ンヴー]+$']}
                errorMessages={['必須項目を入力してください', 'カタカナで入力してください']}
                helperText="カタカナ入力"
              />
              <br/>
              <TextValidator
                className={classes.textField}
                name="lastName"
                label="氏"
                value={lastName}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'lastName')}
                onFocus ={() => this.handleleOnFocus("yes", "lastName")}
                onBlur  ={() => this.handleleOnFocus("no", "lastName")}
                required={true}
                validators={['required']}
                errorMessages={['必須項目を入力してください']}
                helperText={lastNameList.length > 0 ? "氏の候補があります" : ""}
              />
              <Paper
                square
                style={{
                  position: "absolute",
                  zIndex : 1,
                  width: "600px",
                  maxHeight: "300px",
                  marginTop: "-20px",
                  marginLeft : "8px",
                  overflow : "scroll",
                  display: lastNameOnFocus === "yes" && lastNameList.length > 0 ? "" : "none",
                }}
              >
                <div
                  style={{
                    color: "#0000008a",
                    margin: "10px"
                  }}
                >
                  氏の候補
                  <span
                    style={{
                      fontSize: "0.8em",
                      marginLeft: "3px"
                    }}
                  >
                    (世帯数の多い苗字順に表示されます)
                  </span>
                </div>
                {lastNameList.map(n => (
                  <MenuItem
                    key={n}
                    onMouseDown={() => this.handleChange({target:{value: n}}, "lastName")}
                  >
                    {n}
                  </MenuItem>
                ))}
              </Paper>
              <TextValidator
                className={classes.textField}
                name="firstName"
                label="名"
                value={firstName}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'firstName')}
                required={true}
                validators={['required']}
                errorMessages={['必須項目を入力してください']}
              />
              <br/><br/>
              <Typography variant="h6" gutterBottom>
                ご住所
              </Typography>
              <TextValidator
                className={classes.textField}
                name="postNum"
                label="〒 郵便番号"
                value={postNum}
                margin="normal"
                onChange={(e) => this.doSearch(e, 'postNum')}
                onBlur={(e) => this.changeChar(e, 'postNum')}
                required={false}
                validators={['matchRegexp:^\\d{7}$']}
                errorMessages={['郵便番号が間違っています']}
                helperText="ハイフンなし"
              />
              <br/>
              <TextValidator
                className={classes.textField}
                name="addressPrefectures"
                label="都道府県"
                value={addressPrefectures}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'addressPrefectures')}
                required={true}
                validators={['required']}
                errorMessages={['必須項目を入力してください']}
                helperText="ハイフンなし"
              />
              <TextValidator
                className={classes.textField}
                name="addressCity"
                label="市区町村"
                value={addressCity}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'addressCity')}
                required={true}
                validators={['required']}
                errorMessages={['必須項目を入力してください']}
                helperText="ハイフンなし"
              />
              <br/>
              <TextValidator
                className={classes.textField}
                name="addressOther"
                label="以降の住所"
                value={addressOther}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'addressOther')}
                required={true}
                validators={['required']}
                style={{width:'95%'}}
              />
              <br/>
              <TextValidator
                className={classes.textField}
                name="addressBuilding"
                label="建物名"
                value={addressBuilding}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'addressBuilding')}
                style={{width:'95%'}}
              />
              <br/><br/>
              <Typography variant="h6" gutterBottom>
                ご連絡先
              </Typography>
              <TextValidator
                className={classes.textField}
                name="tel"
                label="電話番号"
                value={tel}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'tel')}
                onBlur={(e) => this.changeChar(e, 'tel')}
                type="tel"
                required={true}
                validators={['required', 'matchRegexp:^(0{1}\\d{9,10})$']}
                errorMessages={['必須項目を入力してください', '電話番号が間違っています']}
                helperText="ハイフンなし"
              />
              <TextValidator
                className={classes.textField}
                name="tel2"
                label="電話番号2"
                value={tel2}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'tel2')}
                onBlur={(e) => this.changeChar(e, 'tel2')}
                type="tel"
                validators={['matchRegexp:^(0{1}\\d{9,10})$']}
                errorMessages={['電話番号が間違っています']}
                helperText="固定電話など ハイフンなし"
              />
              <br/>
              <TextValidator
                className={classes.textField}
                name="email"
                label="email"
                value={email}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'email')}
                required={false}
                validators={['isEmail']}
                errorMessages={['emailアドレスが間違っています']}
              />
              <br/>
              <TextValidator
                className={classes.textField}
                name="customerNote"
                label="備考"
                value={customerNote}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'customerNote')}
                required={false}
                multiline={true}
                rows={3}
                style={{width:600}}
              />








              <Button type="submit" variant="contained" color="primary" className={classes.button} style={{marginLeft: "90%", marginTop:40}}>
                更新
              </Button>
            </ValidatorForm>
          </DialogContent>
        </Dialog>


        <Dialog
          open={repeatCustomerOpen}
          onClose={() => this.handleCloseDialog('repeatCustomerOpen')}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          fullWidth={true}
          maxWidth="md"
        >
          <DialogTitle id="scroll-dialog-title">顧客検索</DialogTitle>
          <DialogContent>
          <ValidatorForm
            ref="form"
            onSubmit={() => this.handleSearchCustomers()}
            onError={
              errors => {
                console.log(errors);
                const { enqueueSnackbar } = this.props;
                enqueueSnackbar('検索内容に無効な値が含まれています。', {variant : 'warning'});
              }
            }
          >
            <TextValidator
              className={classes.textField}
              name="lastNameKanaSC"
              label="氏(カナ)"
              value={lastNameKanaSC}
              margin="normal"
              onChange={(e) => this.handleChange(e, 'lastNameKanaSC')}
              pattern="^[ァ-ンヴー]+$ , [\\u30A1-\\u30FF]*"
              validators={['matchRegexp:^[ァ-ンヴー]+$']}
              errorMessages={['カタカナで入力してください']}
              helperText="カタカナ入力"
            />
            <TextValidator
              className={classes.textField}
              name="firstNameKanaSC"
              label="名（カナ）"
              value={firstNameKanaSC}
              margin="normal"
              onChange={(e) => this.handleChange(e, 'firstNameKanaSC')}
              pattern="^[ァ-ンヴー]+$ , [\\u30A1-\\u30FF]*"
              validators={['matchRegexp:^[ァ-ンヴー]+$']}
              errorMessages={['カタカナで入力してください']}
              helperText="カタカナ入力"
            />
            <br/>
            <TextValidator
              className={classes.textField}
              name="telSC"
              label="電話番号"
              value={telSC}
              margin="normal"
              onChange={(e) => this.handleChange(e, 'telSC')}
              type="tel"
              validators={['matchRegexp:^(0{1}\\d{1,10})$']}
              errorMessages={['電話番号形式で入力してください']}
              helperText="ハイフンなし"
            />
            <br/>
            <TextValidator
              className={classes.textField}
              name="emailSC"
              label="email"
              value={emailSC}
              margin="normal"
              onChange={(e) => this.handleChange(e, 'emailSC')}
            />
            <br/>
            <Typography style={{marginLeft: 10, marginTop:20, color:"#8c8c8c"}}>
              ※入力されている項目のみで前方一致の絞り込み検索
            </Typography>
            <br/>
            <Button type="submit" variant="contained" color="primary" className={classes.button} style={{marginTop:40}}>
              検索
            </Button>
          </ValidatorForm>
          <br/>
          <Chip
            label={"該当件数:　　　" + searchCustomersResult.length}
            className={classes.chip}
            style={{marginTop:20, marginLeft:"63%", width:150, backgroundColor:"#efefef"}}
          />
          {searchCustomersResult.map(n =>
            {
              return (
                <Card style={{width:"80%", marginTop:20, background: "#ececec"}} key={n.customer_id}>
                  <CardActionArea onClick={() => this.setRepeatCustomer(n.customer_id)}>
                    <CardContent>
                      <Typography className={classes.title} color="textSecondary" gutterBottom>
                        {n.last_name_kana} {n.first_name_kana}
                      </Typography>
                      <Typography variant="h5" component="h2">
                        {n.last_name} {n.first_name} <div style={{marginLeft: 10, fontSize:"0.8em", display: "inline"}}>様</div>
                      </Typography>
                      <Typography variant="caption" style={{marginTop:10, marginBottom:8}}>
                        前回宿泊開始日
                      </Typography>
                      <Typography variant="body1" style={{marginLeft:5}}>
                        {n.reservation_date_history[0]}
                      </Typography>
                      <Typography variant="caption" style={{marginTop:10, marginBottom:8}}>
                        住所
                      </Typography>
                      <Typography variant="body1" style={{marginLeft:5}}>
                        {n.post_num}<br/>
                        {n.address_prefectures} {n.address_city} {n.address_other} {n.address_building}
                      </Typography>
                      <Typography variant="caption" style={{marginTop:10, marginBottom:8}}>
                        電話番号
                      </Typography>
                      <Typography variant="body1" style={{marginLeft:5}}>
                        {n.tel}
                      </Typography>
                      {n.tel2 &&
                        <Fragment>
                          <Typography variant="caption" style={{marginTop:10, marginBottom:8}}>
                            電話番号2
                          </Typography>
                          <Typography variant="body1" style={{marginLeft:5}}>
                            {n.tel2}
                          </Typography>
                        </Fragment>
                      }
                      {n.email &&
                        <Fragment>
                          <Typography variant="caption" style={{marginTop:10, marginBottom:8}}>
                            email
                          </Typography>
                          <Typography variant="body1" style={{marginLeft:5}}>
                            {n.email}
                          </Typography>
                        </Fragment>
                      }
                      {n.customer_note &&
                        <Fragment>
                          <Typography variant="caption" style={{marginTop:10, marginBottom:8}}>
                            備考
                          </Typography>
                          <Typography variant="body1" style={{marginLeft:5}}>
                            {this.nl2brJsx(n.customer_note)}
                          </Typography>
                        </Fragment>
                      }
                    </CardContent>
                  </CardActionArea>
                </Card>
              );
            }
          )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.handleCloseDialog('repeatCustomerOpen')} color="primary">
              閉じる
            </Button>
          </DialogActions>
        </Dialog>


        <Dialog
          open={this.state.cancelOpen}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => this.handleClose('cancelOpen')}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">
            キャンセルしてよろしいですか？
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              キャンセルした予約は、<br/>
              もとに戻すことができません。<br/><br/>
              もう一度予約を受け付ける際には、新しい予約を作成してください。
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.handleClose('cancelOpen')} color="primary">
              いいえ
            </Button>
            <Button onClick={this.cancelReservation} color="primary">
              はい
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.printOpen}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => this.handleClose('printOpen')}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">
            ご案内をプリントしますか？
          </DialogTitle>
          <DialogContent>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.handleClose('printOpen')} color="primary">
              いいえ
            </Button>

            <ReactToPrint
              trigger={() => {
                return(
                  <Button color="primary">
                    はい
                  </Button>
                )
              }}
              content={() => this.componentRef}
              onAfterPrint ={() => this.afterPrint()}

            />
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.printReservaionSheetOpen}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => this.handleClose('printReservaionSheetOpen')}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">
            予約表をプリントしますか？
          </DialogTitle>
          <DialogContent>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.handleClose('printReservaionSheetOpen')} color="primary">
              いいえ
            </Button>

            <ReactToPrint
              trigger={() => {
                return(
                  <Button color="primary">
                    はい
                  </Button>
                )
              }}
              content={() => this.componentRefReservationSheel}
              onAfterPrint ={() => this.afterPrint()}

            />
          </DialogActions>
        </Dialog>

        <Dialog
          open={canceledCompleteOpen}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => this.handleClose('canceledCompleteOpen')}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">
            じゃらん再開済にしてよろしいですか？
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              じゃらん再開済処理後は、<br/>
              予約管理画面にこの予約情報が表示されなくなります。<br/><br/>
              じゃらん再開済であることを確認してから実施してください。
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.handleClose('canceledCompleteOpen')} color="primary">
              いいえ
            </Button>
            <Button onClick={this.canceledComplete} color="primary">
              はい
            </Button>
          </DialogActions>
        </Dialog>


      </Fragment>
    );
  }
}

ReservationManage.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withSnackbar(withRouter(withStyles(styles, { withTheme: true })(ReservationManage)));
